<template>
  <!--
      作者 WuYuseng
      时间：2019-10-26
      描述：物流编码
  -->
  <div class="express-company">
    <div class="common-form">物流公司列表</div>

    <div class="product-content">
      <div class="table-wrap">
        <div>友情提示：可使用Ctrl+F键 快速检索</div>
        <div class="mt16">
          <table class="">
            <tbody>
              <tr>
                <th>公司名称</th>
                <th>公司编码</th>
              </tr>
              <tr>
                <td>金岸物流</td>
                <td>jinan</td>
              </tr>
              <tr>
                <td>海带宝</td>
                <td>haidaibao</td>
              </tr>
              <tr>
                <td>澳通华人物流</td>
                <td>cllexpress</td>
              </tr>
              <tr>
                <td>斑马物流</td>
                <td>banma</td>
              </tr>
              <tr>
                <td>信丰物流</td>
                <td>xinfengwuliu</td>
              </tr>
              <tr>
                <td>德国(Deutsche Post)</td>
                <td>deutschepost</td>
              </tr>
              <tr>
                <td>苏宁订单</td>
                <td>suningorder</td>
              </tr>
              <tr>
                <td>宜送物流</td>
                <td>yiex</td>
              </tr>
              <tr>
                <td>AOL澳通速递</td>
                <td>aolau</td>
              </tr>
              <tr>
                <td>TRAKPAK</td>
                <td>trakpak</td>
              </tr>
              <tr>
                <td>GTS快递</td>
                <td>gts</td>
              </tr>
              <tr>
                <td>通达兴物流</td>
                <td>tongdaxing</td>
              </tr>
              <tr>
                <td>中国香港(HongKong Post)英文</td>
                <td>hkposten</td>
              </tr>
              <tr>
                <td>骏丰国际速递</td>
                <td>junfengguoji</td>
              </tr>
              <tr>
                <td>俄罗斯邮政(Russian Post)</td>
                <td>pochta</td>
              </tr>
              <tr>
                <td>云达通</td>
                <td>ydglobe</td>
              </tr>
              <tr>
                <td>EU-EXPRESS</td>
                <td>euexpress</td>
              </tr>
              <tr>
                <td>广州海关</td>
                <td>gzcustoms</td>
              </tr>
              <tr>
                <td>杭州海关</td>
                <td>hzcustoms</td>
              </tr>
              <tr>
                <td>南京海关</td>
                <td>njcustoms</td>
              </tr>
              <tr>
                <td>北京海关</td>
                <td>bjcustoms</td>
              </tr>
              <tr>
                <td>美西快递</td>
                <td>meixi</td>
              </tr>
              <tr>
                <td>一站通快递</td>
                <td>zgyzt</td>
              </tr>
              <tr>
                <td>易联通达</td>
                <td>el56</td>
              </tr>
              <tr>
                <td>驿扬国际速运</td>
                <td>iyoungspeed</td>
              </tr>
              <tr>
                <td>途鲜物流</td>
                <td>ibenben</td>
              </tr>
              <tr>
                <td>豌豆物流</td>
                <td>wandougongzhu</td>
              </tr>
              <tr>
                <td>哥士传奇速递</td>
                <td>gscq365</td>
              </tr>
              <tr>
                <td>心怡物流</td>
                <td>alog</td>
              </tr>
              <tr>
                <td>ME物流</td>
                <td>macroexpressco</td>
              </tr>
              <tr>
                <td>疯狂快递</td>
                <td>crazyexpress</td>
              </tr>
              <tr>
                <td>韩国邮政韩文</td>
                <td>koreapostkr</td>
              </tr>
              <tr>
                <td>全速物流</td>
                <td>quansu</td>
              </tr>
              <tr>
                <td>新杰物流</td>
                <td>sunjex</td>
              </tr>
              <tr>
                <td>鲁通快运</td>
                <td>lutong</td>
              </tr>
              <tr>
                <td>安的快递</td>
                <td>gda</td>
              </tr>
              <tr>
                <td>八达通</td>
                <td>bdatong</td>
              </tr>
              <tr>
                <td>美国申通</td>
                <td>stoexpress</td>
              </tr>
              <tr>
                <td>法国小包（colissimo）</td>
                <td>colissimo</td>
              </tr>
              <tr>
                <td>泛捷国际速递</td>
                <td>epanex</td>
              </tr>
              <tr>
                <td>中远e环球</td>
                <td>cosco</td>
              </tr>
              <tr>
                <td>顺达快递</td>
                <td>sundarexpress</td>
              </tr>
              <tr>
                <td>捷记方舟</td>
                <td>ajexpress</td>
              </tr>
              <tr>
                <td>方舟速递</td>
                <td>arkexpress</td>
              </tr>
              <tr>
                <td>明大快递</td>
                <td>adaexpress</td>
              </tr>
              <tr>
                <td>长江国际速递</td>
                <td>changjiang</td>
              </tr>
              <tr>
                <td>PCA Express</td>
                <td>pcaexpress</td>
              </tr>
              <tr>
                <td>洋包裹</td>
                <td>yangbaoguo</td>
              </tr>
              <tr>
                <td>优联吉运</td>
                <td>uluckex</td>
              </tr>
              <tr>
                <td>德豪驿</td>
                <td>dehaoyi</td>
              </tr>
              <tr>
                <td>堡昕德速递</td>
                <td>bosind</td>
              </tr>
              <tr>
                <td>阿根廷(Correo Argentina)</td>
                <td>correoargentino</td>
              </tr>
              <tr>
                <td>秘鲁(SERPOST)</td>
                <td>peru</td>
              </tr>
              <tr>
                <td>哈萨克斯坦(Kazpost)</td>
                <td>kazpost</td>
              </tr>
              <tr>
                <td>广通速递</td>
                <td>gtongsudi</td>
              </tr>
              <tr>
                <td>东瀚物流</td>
                <td>donghanwl</td>
              </tr>
              <tr>
                <td>rpx</td>
                <td>rpx</td>
              </tr>
              <tr>
                <td>黑猫雅玛多</td>
                <td>yamato</td>
              </tr>
              <tr>
                <td>华通快运</td>
                <td>htongexpress</td>
              </tr>
              <tr>
                <td>吉尔吉斯斯坦(Kyrgyz Post)</td>
                <td>kyrgyzpost</td>
              </tr>
              <tr>
                <td>拉脱维亚(Latvijas Pasts)</td>
                <td>latvia</td>
              </tr>
              <tr>
                <td>黎巴嫩(Liban Post)</td>
                <td>libanpost</td>
              </tr>
              <tr>
                <td>立陶宛（Lietuvos pa?tas）</td>
                <td>lithuania</td>
              </tr>
              <tr>
                <td>马尔代夫(Maldives Post)</td>
                <td>maldives</td>
              </tr>
              <tr>
                <td>马耳他（Malta Post）</td>
                <td>malta</td>
              </tr>
              <tr>
                <td>马其顿(Macedonian Post)</td>
                <td>macedonia</td>
              </tr>
              <tr>
                <td>新西兰（New Zealand Post）</td>
                <td>newzealand</td>
              </tr>
              <tr>
                <td>摩尔多瓦(Posta Moldovei)</td>
                <td>moldova</td>
              </tr>
              <tr>
                <td>塞尔维亚(PE Post of Serbia)</td>
                <td>serbia</td>
              </tr>
              <tr>
                <td>塞浦路斯(Cyprus Post)</td>
                <td>cypruspost</td>
              </tr>
              <tr>
                <td>突尼斯EMS(Rapid-Poste)</td>
                <td>tunisia</td>
              </tr>
              <tr>
                <td>乌兹别克斯坦(Post of Uzbekistan)</td>
                <td>uzbekistan</td>
              </tr>
              <tr>
                <td>新喀里多尼亚[法国](New Caledonia)</td>
                <td>caledonia</td>
              </tr>
              <tr>
                <td>叙利亚(Syrian Post)</td>
                <td>republic</td>
              </tr>
              <tr>
                <td>亚美尼亚(Haypost-Armenian Postal)</td>
                <td>haypost</td>
              </tr>
              <tr>
                <td>也门(Yemen Post)</td>
                <td>yemen</td>
              </tr>
              <tr>
                <td>印度(India Post)</td>
                <td>india</td>
              </tr>
              <tr>
                <td>英国(大包,EMS)</td>
                <td>england</td>
              </tr>
              <tr>
                <td>约旦(Jordan Post)</td>
                <td>jordan</td>
              </tr>
              <tr>
                <td>越南小包(Vietnam Posts)</td>
                <td>vietnam</td>
              </tr>
              <tr>
                <td>黑山(Po?ta Crne Gore)</td>
                <td>montenegro</td>
              </tr>
              <tr>
                <td>哥斯达黎加(Correos de Costa Rica)</td>
                <td>correos</td>
              </tr>
              <tr>
                <td>EFS Post（平安快递）</td>
                <td>efs</td>
              </tr>
              <tr>
                <td>TNT Post</td>
                <td>tntpostcn</td>
              </tr>
              <tr>
                <td>立白宝凯物流</td>
                <td>lbbk</td>
              </tr>
              <tr>
                <td>匈牙利（Magyar Posta）</td>
                <td>hungary</td>
              </tr>
              <tr>
                <td>中国澳门(Macau Post)</td>
                <td>macao</td>
              </tr>
              <tr>
                <td>西安喜来快递</td>
                <td>xilaikd</td>
              </tr>
              <tr>
                <td>韩润</td>
                <td>hanrun</td>
              </tr>
              <tr>
                <td>格陵兰[丹麦]（TELE Greenland A/S）</td>
                <td>greenland</td>
              </tr>
              <tr>
                <td>菲律宾（Philippine Postal）</td>
                <td>phlpost</td>
              </tr>
              <tr>
                <td>厄瓜多尔(Correos del Ecuador)</td>
                <td>ecuador</td>
              </tr>
              <tr>
                <td>冰岛(Iceland Post)</td>
                <td>iceland</td>
              </tr>
              <tr>
                <td>波兰小包(Poczta Polska)</td>
                <td>emonitoring</td>
              </tr>
              <tr>
                <td>阿尔巴尼亚(Posta shqipatre)</td>
                <td>albania</td>
              </tr>
              <tr>
                <td>埃及（Egypt Post）</td>
                <td>egypt</td>
              </tr>
              <tr>
                <td>爱沙尼亚(Eesti Post)</td>
                <td>omniva</td>
              </tr>
              <tr>
                <td>云豹国际货运</td>
                <td>leopard</td>
              </tr>
              <tr>
                <td>中外运空运</td>
                <td>sinoairinex</td>
              </tr>
              <tr>
                <td>上海昊宏国际货物</td>
                <td>hyk</td>
              </tr>
              <tr>
                <td>城晓国际快递</td>
                <td>ckeex</td>
              </tr>
              <tr>
                <td>中铁快运</td>
                <td>ztky</td>
              </tr>
              <tr>
                <td>出口易</td>
                <td>chukou1</td>
              </tr>
              <tr>
                <td>跨畅（直邮易）</td>
                <td>kuachangwuliu</td>
              </tr>
              <tr>
                <td>WTD海外通</td>
                <td>wtdex</td>
              </tr>
              <tr>
                <td>CHS中环国际快递</td>
                <td>chszhonghuanguoji</td>
              </tr>
              <tr>
                <td>汉邦国际速递</td>
                <td>handboy</td>
              </tr>
              <tr>
                <td>银河物流</td>
                <td>milkyway</td>
              </tr>
              <tr>
                <td>荷兰速递(Nederland Post)</td>
                <td>nederlandpost</td>
              </tr>
              <tr>
                <td>澳州顺风快递</td>
                <td>emms</td>
              </tr>
              <tr>
                <td>环东物流</td>
                <td>huandonglg</td>
              </tr>
              <tr>
                <td>中邮速递</td>
                <td>wondersyd</td>
              </tr>
              <tr>
                <td>布谷鸟速递</td>
                <td>cuckooexpess</td>
              </tr>
              <tr>
                <td>万庚国际速递</td>
                <td>vangenexpress</td>
              </tr>
              <tr>
                <td>FedRoad 联邦转运</td>
                <td>fedroad</td>
              </tr>
              <tr>
                <td>Landmark Global</td>
                <td>landmarkglobal</td>
              </tr>
              <tr>
                <td>佳成快递</td>
                <td>jiacheng</td>
              </tr>
              <tr>
                <td>诺尔国际物流</td>
                <td>nuoer</td>
              </tr>
              <tr>
                <td>加运美速递</td>
                <td>jym56</td>
              </tr>
              <tr>
                <td>新时速物流</td>
                <td>csxss</td>
              </tr>
              <tr>
                <td>中宇天地</td>
                <td>zytdscm</td>
              </tr>
              <tr>
                <td>翔腾物流</td>
                <td>xiangteng</td>
              </tr>
              <tr>
                <td>恒瑞物流</td>
                <td>hengrui56</td>
              </tr>
              <tr>
                <td>中国翼</td>
                <td>cnws</td>
              </tr>
              <tr>
                <td>邦工快运</td>
                <td>bgky100</td>
              </tr>
              <tr>
                <td>上海无疆for买卖宝</td>
                <td>shanghaiwujiangmmb</td>
              </tr>
              <tr>
                <td>新加坡小包(Singapore Post)</td>
                <td>singpost</td>
              </tr>
              <tr>
                <td>中俄速通（淼信）</td>
                <td>mxe56</td>
              </tr>
              <tr>
                <td>海派通</td>
                <td>hipito</td>
              </tr>
              <tr>
                <td>源安达</td>
                <td>yuananda</td>
              </tr>
              <tr>
                <td>赛澳递for买卖宝</td>
                <td>saiaodimmb</td>
              </tr>
              <tr>
                <td>ECMS Express</td>
                <td>ecmsglobal</td>
              </tr>
              <tr>
                <td>英脉物流</td>
                <td>gml</td>
              </tr>
              <tr>
                <td>佳家通货运</td>
                <td>jiajiatong56</td>
              </tr>
              <tr>
                <td>吉日优派</td>
                <td>jrypex</td>
              </tr>
              <tr>
                <td>西安胜峰</td>
                <td>xaetc</td>
              </tr>
              <tr>
                <td>logen路坚</td>
                <td>ilogen</td>
              </tr>
              <tr>
                <td>amazon-国际订单</td>
                <td>amusorder</td>
              </tr>
              <tr>
                <td>CJ物流</td>
                <td>doortodoor</td>
              </tr>
              <tr>
                <td>转运四方</td>
                <td>zhuanyunsifang</td>
              </tr>
              <tr>
                <td>成都东骏物流</td>
                <td>dongjun</td>
              </tr>
              <tr>
                <td>日本郵便</td>
                <td>japanpost</td>
              </tr>
              <tr>
                <td>猴急送</td>
                <td>hjs</td>
              </tr>
              <tr>
                <td>全信通快递</td>
                <td>quanxintong</td>
              </tr>
              <tr>
                <td>信天捷快递</td>
                <td>xintianjie</td>
              </tr>
              <tr>
                <td>泰国138国际物流</td>
                <td>sd138</td>
              </tr>
              <tr>
                <td>荷兰包裹(PostNL International Parcels)</td>
                <td>postnlpacle</td>
              </tr>
              <tr>
                <td>乐天速递</td>
                <td>ltexp</td>
              </tr>
              <tr>
                <td>智通物流</td>
                <td>ztong</td>
              </tr>
              <tr>
                <td>全速通</td>
                <td>quansutong</td>
              </tr>
              <tr>
                <td>中技物流</td>
                <td>zhongjiwuliu</td>
              </tr>
              <tr>
                <td>九曳供应链</td>
                <td>jiuyescm</td>
              </tr>
              <tr>
                <td>当当</td>
                <td>dangdang</td>
              </tr>
              <tr>
                <td>美龙快递</td>
                <td>mjexp</td>
              </tr>
              <tr>
                <td>唯品会(vip)</td>
                <td>vipshop</td>
              </tr>
              <tr>
                <td>1号店</td>
                <td>yhdshop</td>
              </tr>
              <tr>
                <td>皇家物流</td>
                <td>pfcexpress</td>
              </tr>
              <tr>
                <td>百千诚物流</td>
                <td>bqcwl</td>
              </tr>
              <tr>
                <td>法国(La Poste)</td>
                <td>csuivi</td>
              </tr>
              <tr>
                <td>DHL-全球件</td>
                <td>dhlen</td>
              </tr>
              <tr>
                <td>运通中港</td>
                <td>yuntongkuaidi</td>
              </tr>
              <tr>
                <td>苏宁物流</td>
                <td>suning</td>
              </tr>
              <tr>
                <td>荷兰Sky Post</td>
                <td>skypost</td>
              </tr>
              <tr>
                <td>瑞达国际速递</td>
                <td>ruidaex</td>
              </tr>
              <tr>
                <td>丰程物流</td>
                <td>sccod</td>
              </tr>
              <tr>
                <td>德中快递</td>
                <td>decnlh</td>
              </tr>
              <tr>
                <td>全时速运</td>
                <td>runhengfeng</td>
              </tr>
              <tr>
                <td>云邮跨境快递</td>
                <td>hkems</td>
              </tr>
              <tr>
                <td>亚风速递</td>
                <td>yafengsudi</td>
              </tr>
              <tr>
                <td>快淘快递</td>
                <td>kuaitao</td>
              </tr>
              <tr>
                <td>鑫通宝物流</td>
                <td>xtb</td>
              </tr>
              <tr>
                <td>USPS</td>
                <td>usps</td>
              </tr>
              <tr>
                <td>加拿大邮政</td>
                <td>canpostfr</td>
              </tr>
              <tr>
                <td>汇通天下物流</td>
                <td>httx56</td>
              </tr>
              <tr>
                <td>台湾（中华邮政）</td>
                <td>postserv</td>
              </tr>
              <tr>
                <td>好又快物流</td>
                <td>haoyoukuai</td>
              </tr>
              <tr>
                <td>永旺达快递</td>
                <td>yongwangda</td>
              </tr>
              <tr>
                <td>木春货运</td>
                <td>mchy</td>
              </tr>
              <tr>
                <td>程光快递</td>
                <td>flyway</td>
              </tr>
              <tr>
                <td>百事亨通</td>
                <td>bsht</td>
              </tr>
              <tr>
                <td>万家通快递</td>
                <td>timedg</td>
              </tr>
              <tr>
                <td>全之鑫物流</td>
                <td>qzx56</td>
              </tr>
              <tr>
                <td>美快国际物流</td>
                <td>meiquick</td>
              </tr>
              <tr>
                <td>ILYANG</td>
                <td>ilyang</td>
              </tr>
              <tr>
                <td>先锋快递</td>
                <td>xianfeng</td>
              </tr>
              <tr>
                <td>亿顺航</td>
                <td>yishunhang</td>
              </tr>
              <tr>
                <td>尚橙物流</td>
                <td>shangcheng</td>
              </tr>
              <tr>
                <td>OnTrac</td>
                <td>ontrac</td>
              </tr>
              <tr>
                <td>TNT-全球件</td>
                <td>tnten</td>
              </tr>
              <tr>
                <td>顺丰-美国件</td>
                <td>shunfengen</td>
              </tr>
              <tr>
                <td>共速达</td>
                <td>gongsuda</td>
              </tr>
              <tr>
                <td>源伟丰</td>
                <td>yuanweifeng</td>
              </tr>
              <tr>
                <td>祥龙运通物流</td>
                <td>xianglongyuntong</td>
              </tr>
              <tr>
                <td>偌亚奥国际快递</td>
                <td>nuoyaao</td>
              </tr>
              <tr>
                <td>陪行物流</td>
                <td>peixingwuliu</td>
              </tr>
              <tr>
                <td>天天快递</td>
                <td>tiantian</td>
              </tr>
              <tr>
                <td>CCES/国通快递</td>
                <td>cces</td>
              </tr>
              <tr>
                <td>彪记快递</td>
                <td>biaojikuaidi</td>
              </tr>
              <tr>
                <td>安信达</td>
                <td>anxindakuaixi</td>
              </tr>
              <tr>
                <td>配思货运</td>
                <td>peisihuoyunkuaidi</td>
              </tr>
              <tr>
                <td>大田物流</td>
                <td>datianwuliu</td>
              </tr>
              <tr>
                <td>邮政快递包裹</td>
                <td>youzhengguonei</td>
              </tr>
              <tr>
                <td>文捷航空</td>
                <td>wenjiesudi</td>
              </tr>
              <tr>
                <td>BHT</td>
                <td>bht</td>
              </tr>
              <tr>
                <td>北青小红帽</td>
                <td>xiaohongmao</td>
              </tr>
              <tr>
                <td>GSM</td>
                <td>gsm</td>
              </tr>
              <tr>
                <td>汇强快递</td>
                <td>huiqiangkuaidi</td>
              </tr>
              <tr>
                <td>昊盛物流</td>
                <td>haoshengwuliu</td>
              </tr>
              <tr>
                <td>联邦快递-英文</td>
                <td>lianbangkuaidien</td>
              </tr>
              <tr>
                <td>伍圆速递</td>
                <td>wuyuansudi</td>
              </tr>
              <tr>
                <td>南京100</td>
                <td>nanjing</td>
              </tr>
              <tr>
                <td>全通快运</td>
                <td>quantwl</td>
              </tr>
              <tr>
                <td>宅急便</td>
                <td>zhaijibian</td>
              </tr>
              <tr>
                <td>加拿大(Canada Post)</td>
                <td>canpost</td>
              </tr>
              <tr>
                <td>COE</td>
                <td>coe</td>
              </tr>
              <tr>
                <td>百通物流</td>
                <td>buytong</td>
              </tr>
              <tr>
                <td>友家速递</td>
                <td>youjia</td>
              </tr>
              <tr>
                <td>新元快递</td>
                <td>xingyuankuaidi</td>
              </tr>
              <tr>
                <td>中澳速递</td>
                <td>cnausu</td>
              </tr>
              <tr>
                <td>联合快递</td>
                <td>gslhkd</td>
              </tr>
              <tr>
                <td>河南次晨达</td>
                <td>ccd</td>
              </tr>
              <tr>
                <td>奔腾物流</td>
                <td>benteng</td>
              </tr>
              <tr>
                <td>今枫国际快运</td>
                <td>mapleexpress</td>
              </tr>
              <tr>
                <td>中运全速</td>
                <td>topspeedex</td>
              </tr>
              <tr>
                <td>中欧快运</td>
                <td>otobv</td>
              </tr>
              <tr>
                <td>宜家行</td>
                <td>yjxlm</td>
              </tr>
              <tr>
                <td>金马甲</td>
                <td>jmjss</td>
              </tr>
              <tr>
                <td>一号仓</td>
                <td>onehcang</td>
              </tr>
              <tr>
                <td>论道国际物流</td>
                <td>lundao</td>
              </tr>
              <tr>
                <td>顺通快递</td>
                <td>stkd</td>
              </tr>
              <tr>
                <td>globaltracktrace</td>
                <td>globaltracktrace</td>
              </tr>
              <tr>
                <td>德方物流</td>
                <td>ahdf</td>
              </tr>
              <tr>
                <td>速递中国</td>
                <td>sendtochina</td>
              </tr>
              <tr>
                <td>NLE</td>
                <td>nle</td>
              </tr>
              <tr>
                <td>亚欧专线</td>
                <td>nlebv</td>
              </tr>
              <tr>
                <td>信联通</td>
                <td>sinatone</td>
              </tr>
              <tr>
                <td>澳德物流</td>
                <td>auod</td>
              </tr>
              <tr>
                <td>微转运</td>
                <td>wzhaunyun</td>
              </tr>
              <tr>
                <td>iExpress</td>
                <td>iexpress</td>
              </tr>
              <tr>
                <td>远成快运</td>
                <td>ycgky</td>
              </tr>
              <tr>
                <td>高考通知书</td>
                <td>emsluqu</td>
              </tr>
              <tr>
                <td>安鲜达</td>
                <td>exfresh</td>
              </tr>
              <tr>
                <td>BCWELT</td>
                <td>bcwelt</td>
              </tr>
              <tr>
                <td>欧亚专线</td>
                <td>euasia</td>
              </tr>
              <tr>
                <td>乐递供应链</td>
                <td>ledii</td>
              </tr>
              <tr>
                <td>万通快递</td>
                <td>gswtkd</td>
              </tr>
              <tr>
                <td>特急送</td>
                <td>lntjs</td>
              </tr>
              <tr>
                <td>金大物流</td>
                <td>jindawuliu</td>
              </tr>
              <tr>
                <td>民航快递</td>
                <td>minghangkuaidi</td>
              </tr>
              <tr>
                <td>红马甲物流</td>
                <td>sxhongmajia</td>
              </tr>
              <tr>
                <td>amazon-国内订单</td>
                <td>amcnorder</td>
              </tr>
              <tr>
                <td>ABF</td>
                <td>abf</td>
              </tr>
              <tr>
                <td>小米</td>
                <td>xiaomi</td>
              </tr>
              <tr>
                <td>新元国际</td>
                <td>xynyc</td>
              </tr>
              <tr>
                <td>小C海淘</td>
                <td>xiaocex</td>
              </tr>
              <tr>
                <td>航空快递</td>
                <td>airgtc</td>
              </tr>
              <tr>
                <td>叮咚澳洲转运</td>
                <td>dindon</td>
              </tr>
              <tr>
                <td>环球通达</td>
                <td>hqtd</td>
              </tr>
              <tr>
                <td>新西兰中通</td>
                <td>nzzto</td>
              </tr>
              <tr>
                <td>良藤国际速递</td>
                <td>lmfex</td>
              </tr>
              <tr>
                <td>速品快递</td>
                <td>supinexpress</td>
              </tr>
              <tr>
                <td>海龟国际快递</td>
                <td>turtle</td>
              </tr>
              <tr>
                <td>韩国邮政</td>
                <td>koreapostcn</td>
              </tr>
              <tr>
                <td>韵丰物流</td>
                <td>yunfeng56</td>
              </tr>
              <tr>
                <td>易达通快递</td>
                <td>qexpress</td>
              </tr>
              <tr>
                <td>一运全成物流</td>
                <td>yyqc56</td>
              </tr>
              <tr>
                <td>泛远国际物流</td>
                <td>farlogistis</td>
              </tr>
              <tr>
                <td>达速物流</td>
                <td>dasu</td>
              </tr>
              <tr>
                <td>恒通快递</td>
                <td>lqht</td>
              </tr>
              <tr>
                <td>壹品速递</td>
                <td>ypsd</td>
              </tr>
              <tr>
                <td>鹰运国际速递</td>
                <td>vipexpress</td>
              </tr>
              <tr>
                <td>南方传媒物流</td>
                <td>ndwl</td>
              </tr>
              <tr>
                <td>速呈宅配</td>
                <td>sucheng</td>
              </tr>
              <tr>
                <td>云南滇驿物流</td>
                <td>dianyi</td>
              </tr>
              <tr>
                <td>四川星程快递</td>
                <td>scxingcheng</td>
              </tr>
              <tr>
                <td>运通中港快递</td>
                <td>ytkd</td>
              </tr>
              <tr>
                <td>Gati-英文</td>
                <td>gatien</td>
              </tr>
              <tr>
                <td>jcex</td>
                <td>jcex</td>
              </tr>
              <tr>
                <td>凯信达</td>
                <td>kxda</td>
              </tr>
              <tr>
                <td>安达信</td>
                <td>advancing</td>
              </tr>
              <tr>
                <td>亿翔</td>
                <td>yxexpress</td>
              </tr>
              <tr>
                <td>加运美</td>
                <td>jiayunmeiwuliu</td>
              </tr>
              <tr>
                <td>赛澳递</td>
                <td>saiaodi</td>
              </tr>
              <tr>
                <td>康力物流</td>
                <td>kangliwuliu</td>
              </tr>
              <tr>
                <td>鑫飞鸿</td>
                <td>xinhongyukuaidi</td>
              </tr>
              <tr>
                <td>全一快递</td>
                <td>quanyikuaidi</td>
              </tr>
              <tr>
                <td>华企快运</td>
                <td>huaqikuaiyun</td>
              </tr>
              <tr>
                <td>青岛安捷快递</td>
                <td>anjiekuaidi</td>
              </tr>
              <tr>
                <td>递四方</td>
                <td>disifang</td>
              </tr>
              <tr>
                <td>三态速递</td>
                <td>santaisudi</td>
              </tr>
              <tr>
                <td>成都立即送</td>
                <td>lijisong</td>
              </tr>
              <tr>
                <td>河北建华</td>
                <td>hebeijianhua</td>
              </tr>
              <tr>
                <td>风行天下</td>
                <td>fengxingtianxia</td>
              </tr>
              <tr>
                <td>一统飞鸿</td>
                <td>yitongfeihong</td>
              </tr>
              <tr>
                <td>海外环球</td>
                <td>haiwaihuanqiu</td>
              </tr>
              <tr>
                <td>DHL-中国件</td>
                <td>dhl</td>
              </tr>
              <tr>
                <td>西安城联速递</td>
                <td>xianchengliansudi</td>
              </tr>
              <tr>
                <td>一柒国际物流</td>
                <td>yiqiguojiwuliu</td>
              </tr>
              <tr>
                <td>广东通路</td>
                <td>guangdongtonglu</td>
              </tr>
              <tr>
                <td>中国香港骏辉物流</td>
                <td>chunfai</td>
              </tr>
              <tr>
                <td>三三国际物流</td>
                <td>zenzen</td>
              </tr>
              <tr>
                <td>比利时国际(Bpost international)</td>
                <td>bpostinter</td>
              </tr>
              <tr>
                <td>海红for买卖宝</td>
                <td>haihongmmb</td>
              </tr>
              <tr>
                <td>FedEx-英国件（FedEx UK)</td>
                <td>fedexuk</td>
              </tr>
              <tr>
                <td>FedEx-英国件</td>
                <td>fedexukcn</td>
              </tr>
              <tr>
                <td>叮咚快递</td>
                <td>dingdong</td>
              </tr>
              <tr>
                <td>MRW</td>
                <td>mrw</td>
              </tr>
              <tr>
                <td>Chronopost Portugal</td>
                <td>chronopostport</td>
              </tr>
              <tr>
                <td>西班牙(Correos de Espa?a)</td>
                <td>correosdees</td>
              </tr>
              <tr>
                <td>丹麦(Post Denmark)</td>
                <td>postdanmarken</td>
              </tr>
              <tr>
                <td>Purolator</td>
                <td>purolator</td>
              </tr>
              <tr>
                <td>法国大包、EMS-法文（Chronopost France）</td>
                <td>chronopostfra</td>
              </tr>
              <tr>
                <td>Selektvracht</td>
                <td>selektvracht</td>
              </tr>
              <tr>
                <td>蓝弧快递</td>
                <td>lanhukuaidi</td>
              </tr>
              <tr>
                <td>比利时(Belgium Post)</td>
                <td>belgiumpost</td>
              </tr>
              <tr>
                <td>晟邦物流</td>
                <td>nanjingshengbang</td>
              </tr>
              <tr>
                <td>UPS Mail Innovations</td>
                <td>upsmailinno</td>
              </tr>
              <tr>
                <td>挪威（Posten Norge）</td>
                <td>postennorge</td>
              </tr>
              <tr>
                <td>瑞士(Swiss Post)</td>
                <td>swisspost</td>
              </tr>
              <tr>
                <td>英国邮政小包</td>
                <td>royalmailcn</td>
              </tr>
              <tr>
                <td>英国小包（Royal Mail）</td>
                <td>royalmail</td>
              </tr>
              <tr>
                <td>DHL Benelux</td>
                <td>dhlbenelux</td>
              </tr>
              <tr>
                <td>DHL-荷兰（DHL Netherlands）</td>
                <td>dhlnetherlands</td>
              </tr>
              <tr>
                <td>OPEK</td>
                <td>opek</td>
              </tr>
              <tr>
                <td>Italy SDA</td>
                <td>italysad</td>
              </tr>
              <tr>
                <td>Fastway Ireland</td>
                <td>fastway</td>
              </tr>
              <tr>
                <td>DHL-波兰（DHL Poland）</td>
                <td>dhlpoland</td>
              </tr>
              <tr>
                <td>DPD</td>
                <td>dpd</td>
              </tr>
              <tr>
                <td>速通物流</td>
                <td>sutongwuliu</td>
              </tr>
              <tr>
                <td>荷兰邮政-中文(PostNL international registered mail)</td>
                <td>postnlcn</td>
              </tr>
              <tr>
                <td>荷兰邮政(PostNL international registered mail)</td>
                <td>postnl</td>
              </tr>
              <tr>
                <td>乌克兰EMS(EMS Ukraine)</td>
                <td>emsukraine</td>
              </tr>
              <tr>
                <td>乌克兰邮政包裹</td>
                <td>ukrpostcn</td>
              </tr>
              <tr>
                <td>英国大包、EMS（Parcel Force）</td>
                <td>parcelforce</td>
              </tr>
              <tr>
                <td>YODEL</td>
                <td>yodel</td>
              </tr>
              <tr>
                <td>UBI Australia</td>
                <td>gotoubi</td>
              </tr>
              <tr>
                <td>红马速递</td>
                <td>nedahm</td>
              </tr>
              <tr>
                <td>云南诚中物流</td>
                <td>czwlyn</td>
              </tr>
              <tr>
                <td>万博快递</td>
                <td>wanboex</td>
              </tr>
              <tr>
                <td>腾达速递</td>
                <td>nntengda</td>
              </tr>
              <tr>
                <td>郑州速捷</td>
                <td>sujievip</td>
              </tr>
              <tr>
                <td>中睿速递</td>
                <td>zhongruisudi</td>
              </tr>
              <tr>
                <td>中天万运</td>
                <td>zhongtianwanyun</td>
              </tr>
              <tr>
                <td>新蛋奥硕</td>
                <td>neweggozzo</td>
              </tr>
              <tr>
                <td>七天连锁</td>
                <td>sevendays</td>
              </tr>
              <tr>
                <td>UPS-全球件</td>
                <td>upsen</td>
              </tr>
              <tr>
                <td>跨越速运</td>
                <td>kuayue</td>
              </tr>
              <tr>
                <td>全际通</td>
                <td>quanjitong</td>
              </tr>
              <tr>
                <td>UPS</td>
                <td>ups</td>
              </tr>
              <tr>
                <td>一邦速递</td>
                <td>yibangwuliu</td>
              </tr>
              <tr>
                <td>上海快通</td>
                <td>shanghaikuaitong</td>
              </tr>
              <tr>
                <td>品速心达快递</td>
                <td>pinsuxinda</td>
              </tr>
              <tr>
                <td>PostNord(Posten AB)</td>
                <td>postenab</td>
              </tr>
              <tr>
                <td>城际速递</td>
                <td>chengjisudi</td>
              </tr>
              <tr>
                <td>户通物流</td>
                <td>hutongwuliu</td>
              </tr>
              <tr>
                <td>飞康达</td>
                <td>feikangda</td>
              </tr>
              <tr>
                <td>星晨急便</td>
                <td>xingchengjibian</td>
              </tr>
              <tr>
                <td>全日通</td>
                <td>quanritongkuaidi</td>
              </tr>
              <tr>
                <td>凤凰快递</td>
                <td>fenghuangkuaidi</td>
              </tr>
              <tr>
                <td>广东邮政</td>
                <td>guangdongyouzhengwuliu</td>
              </tr>
              <tr>
                <td>长宇物流</td>
                <td>changyuwuliu</td>
              </tr>
              <tr>
                <td>万家物流</td>
                <td>wanjiawuliu</td>
              </tr>
              <tr>
                <td>EMS-国际件-英文</td>
                <td>emsinten</td>
              </tr>
              <tr>
                <td>飞远配送</td>
                <td>feiyuanvipshop</td>
              </tr>
              <tr>
                <td>国美</td>
                <td>gome</td>
              </tr>
              <tr>
                <td>能达速递</td>
                <td>ganzhongnengda</td>
              </tr>
              <tr>
                <td>急先达</td>
                <td>jixianda</td>
              </tr>
              <tr>
                <td>凡宇快递</td>
                <td>fanyukuaidi</td>
              </tr>
              <tr>
                <td>希优特</td>
                <td>xiyoutekuaidi</td>
              </tr>
              <tr>
                <td>中通（带电话）</td>
                <td>zhongtongphone</td>
              </tr>
              <tr>
                <td>蓝镖快递</td>
                <td>lanbiaokuaidi</td>
              </tr>
              <tr>
                <td>佳吉快运</td>
                <td>jiajiwuliu</td>
              </tr>
              <tr>
                <td>宏品物流</td>
                <td>hongpinwuliu</td>
              </tr>
              <tr>
                <td>GLS</td>
                <td>gls</td>
              </tr>
              <tr>
                <td>原飞航</td>
                <td>yuanfeihangwuliu</td>
              </tr>
              <tr>
                <td>海红网送</td>
                <td>haihongwangsong</td>
              </tr>
              <tr>
                <td>TNT</td>
                <td>tnt</td>
              </tr>
              <tr>
                <td>元智捷诚</td>
                <td>yuanzhijiecheng</td>
              </tr>
              <tr>
                <td>国际包裹</td>
                <td>youzhengguoji</td>
              </tr>
              <tr>
                <td>城市100</td>
                <td>city100</td>
              </tr>
              <tr>
                <td>DPEX</td>
                <td>dpex</td>
              </tr>
              <tr>
                <td>芝麻开门</td>
                <td>zhimakaimen</td>
              </tr>
              <tr>
                <td>EMS-国际件</td>
                <td>emsguoji</td>
              </tr>
              <tr>
                <td>晋越快递</td>
                <td>jinyuekuaidi</td>
              </tr>
              <tr>
                <td>乐捷递</td>
                <td>lejiedi</td>
              </tr>
              <tr>
                <td>飞力士物流</td>
                <td>flysman</td>
              </tr>
              <tr>
                <td>百腾物流</td>
                <td>baitengwuliu</td>
              </tr>
              <tr>
                <td>品骏快递</td>
                <td>pjbest</td>
              </tr>
              <tr>
                <td>瓦努阿图(Vanuatu Post)</td>
                <td>vanuatu</td>
              </tr>
              <tr>
                <td>巴巴多斯(Barbados Post)</td>
                <td>barbados</td>
              </tr>
              <tr>
                <td>萨摩亚(Samoa Post)</td>
                <td>samoa</td>
              </tr>
              <tr>
                <td>斐济(Fiji Post)</td>
                <td>fiji</td>
              </tr>
              <tr>
                <td>英超物流</td>
                <td>yingchao</td>
              </tr>
              <tr>
                <td>TNY物流</td>
                <td>tny</td>
              </tr>
              <tr>
                <td>美通</td>
                <td>valueway</td>
              </tr>
              <tr>
                <td>新速航</td>
                <td>sunspeedy</td>
              </tr>
              <tr>
                <td>速方(Sufast)</td>
                <td>bphchina</td>
              </tr>
              <tr>
                <td>华航快递</td>
                <td>hzpl</td>
              </tr>
              <tr>
                <td>Gati-KWE</td>
                <td>gatikwe</td>
              </tr>
              <tr>
                <td>Red Express</td>
                <td>redexpress</td>
              </tr>
              <tr>
                <td>Toll Priority(Toll Online)</td>
                <td>tollpriority</td>
              </tr>
              <tr>
                <td>Estafeta</td>
                <td>estafeta</td>
              </tr>
              <tr>
                <td>港快速递</td>
                <td>gdkd</td>
              </tr>
              <tr>
                <td>墨西哥（Correos de Mexico）</td>
                <td>mexico</td>
              </tr>
              <tr>
                <td>罗马尼亚（Posta Romanian）</td>
                <td>romanian</td>
              </tr>
              <tr>
                <td>DPD Poland</td>
                <td>dpdpoland</td>
              </tr>
              <tr>
                <td>阿联酋(Emirates Post)</td>
                <td>emirates</td>
              </tr>
              <tr>
                <td>新顺丰（NSF）</td>
                <td>nsf</td>
              </tr>
              <tr>
                <td>巴基斯坦(Pakistan Post)</td>
                <td>pakistan</td>
              </tr>
              <tr>
                <td>Asendia USA</td>
                <td>asendiausa</td>
              </tr>
              <tr>
                <td>法国大包、EMS-英文(Chronopost France)</td>
                <td>chronopostfren</td>
              </tr>
              <tr>
                <td>意大利(Poste Italiane)</td>
                <td>italiane</td>
              </tr>
              <tr>
                <td>世运快递</td>
                <td>shiyunkuaidi</td>
              </tr>
              <tr>
                <td>新干线快递</td>
                <td>anlexpress</td>
              </tr>
              <tr>
                <td>飞洋快递</td>
                <td>shipgce</td>
              </tr>
              <tr>
                <td>贝海国际速递</td>
                <td>xlobo</td>
              </tr>
              <tr>
                <td>黄马甲</td>
                <td>huangmajia</td>
              </tr>
              <tr>
                <td>Toll</td>
                <td>dpexen</td>
              </tr>
              <tr>
                <td>如风达</td>
                <td>rufengda</td>
              </tr>
              <tr>
                <td>EC-Firstclass</td>
                <td>ecfirstclass</td>
              </tr>
              <tr>
                <td>DTDC India</td>
                <td>dtdcindia</td>
              </tr>
              <tr>
                <td>Safexpress</td>
                <td>safexpress</td>
              </tr>
              <tr>
                <td>泰国（Thailand Thai Post）</td>
                <td>thailand</td>
              </tr>
              <tr>
                <td>SkyNet Malaysia</td>
                <td>skynetmalaysia</td>
              </tr>
              <tr>
                <td>TNT Australia</td>
                <td>tntau</td>
              </tr>
              <tr>
                <td>马来西亚小包（Malaysia Post(Registered)）</td>
                <td>malaysiapost</td>
              </tr>
              <tr>
                <td>马来西亚大包、EMS（Malaysia Post(parcel,EMS)）</td>
                <td>malaysiaems</td>
              </tr>
              <tr>
                <td>沙特阿拉伯(Saudi Post)</td>
                <td>saudipost</td>
              </tr>
              <tr>
                <td>南非（South African Post Office）</td>
                <td>southafrican</td>
              </tr>
              <tr>
                <td>Mexico Senda Express</td>
                <td>mexicodenda</td>
              </tr>
              <tr>
                <td>MyHermes</td>
                <td>myhermes</td>
              </tr>
              <tr>
                <td>DPD Germany</td>
                <td>dpdgermany</td>
              </tr>
              <tr>
                <td>Nova Poshta</td>
                <td>novaposhta</td>
              </tr>
              <tr>
                <td>Estes</td>
                <td>estes</td>
              </tr>
              <tr>
                <td>TNT UK</td>
                <td>tntuk</td>
              </tr>
              <tr>
                <td>Deltec Courier</td>
                <td>deltec</td>
              </tr>
              <tr>
                <td>UPS Freight</td>
                <td>upsfreight</td>
              </tr>
              <tr>
                <td>TNT Italy</td>
                <td>tntitaly</td>
              </tr>
              <tr>
                <td>Mexico Multipack</td>
                <td>multipack</td>
              </tr>
              <tr>
                <td>葡萄牙（Portugal CTT）</td>
                <td>portugalctt</td>
              </tr>
              <tr>
                <td>Interlink Express</td>
                <td>interlink</td>
              </tr>
              <tr>
                <td>DPD UK</td>
                <td>dpduk</td>
              </tr>
              <tr>
                <td>乌克兰EMS-中文(EMS Ukraine)</td>
                <td>emsukrainecn</td>
              </tr>
              <tr>
                <td>乌克兰小包、大包(UkrPost)</td>
                <td>ukrpost</td>
              </tr>
              <tr>
                <td>TCI XPS</td>
                <td>tcixps</td>
              </tr>
              <tr>
                <td>高铁速递</td>
                <td>hre</td>
              </tr>
              <tr>
                <td>新加坡EMS、大包(Singapore Speedpost)</td>
                <td>speedpost</td>
              </tr>
              <tr>
                <td>LaserShip</td>
                <td>lasership</td>
              </tr>
              <tr>
                <td>英国邮政大包EMS</td>
                <td>parcelforcecn</td>
              </tr>
              <tr>
                <td>同舟行物流</td>
                <td>chinatzx</td>
              </tr>
              <tr>
                <td>秦邦快运</td>
                <td>qbexpress</td>
              </tr>
              <tr>
                <td>skynet</td>
                <td>skynet</td>
              </tr>
              <tr>
                <td>忠信达</td>
                <td>zhongxinda</td>
              </tr>
              <tr>
                <td>门对门</td>
                <td>menduimen</td>
              </tr>
              <tr>
                <td>微特派</td>
                <td>weitepai</td>
              </tr>
              <tr>
                <td>海盟速递</td>
                <td>haimengsudi</td>
              </tr>
              <tr>
                <td>圣安物流</td>
                <td>shenganwuliu</td>
              </tr>
              <tr>
                <td>联邦快递</td>
                <td>lianbangkuaidi</td>
              </tr>
              <tr>
                <td>飞快达</td>
                <td>feikuaida</td>
              </tr>
              <tr>
                <td>EMS</td>
                <td>ems</td>
              </tr>
              <tr>
                <td>天地华宇</td>
                <td>tiandihuayu</td>
              </tr>
              <tr>
                <td>煜嘉物流</td>
                <td>yujiawuliu</td>
              </tr>
              <tr>
                <td>郑州建华</td>
                <td>zhengzhoujianhua</td>
              </tr>
              <tr>
                <td>大洋物流</td>
                <td>dayangwuliu</td>
              </tr>
              <tr>
                <td>递达速运</td>
                <td>didasuyun</td>
              </tr>
              <tr>
                <td>易通达</td>
                <td>yitongda</td>
              </tr>
              <tr>
                <td>邮必佳</td>
                <td>youbijia</td>
              </tr>
              <tr>
                <td>EMS-英文</td>
                <td>emsen</td>
              </tr>
              <tr>
                <td>闽盛快递</td>
                <td>minshengkuaidi</td>
              </tr>
              <tr>
                <td>佳惠尔</td>
                <td>syjiahuier</td>
              </tr>
              <tr>
                <td>KCS</td>
                <td>kcs</td>
              </tr>
              <tr>
                <td>ADP国际快递</td>
                <td>adp</td>
              </tr>
              <tr>
                <td>颿达国际快递</td>
                <td>fardarww</td>
              </tr>
              <tr>
                <td>颿达国际快递-英文</td>
                <td>fandaguoji</td>
              </tr>
              <tr>
                <td>林道国际快递</td>
                <td>shlindao</td>
              </tr>
              <tr>
                <td>中外运速递-中文</td>
                <td>sinoex</td>
              </tr>
              <tr>
                <td>中外运速递</td>
                <td>zhongwaiyun</td>
              </tr>
              <tr>
                <td>深圳德创物流</td>
                <td>dechuangwuliu</td>
              </tr>
              <tr>
                <td>林道国际快递-英文</td>
                <td>ldxpres</td>
              </tr>
              <tr>
                <td>中国香港(HongKong Post)</td>
                <td>hkpost</td>
              </tr>
              <tr>
                <td>邦送物流</td>
                <td>bangsongwuliu</td>
              </tr>
              <tr>
                <td>华赫物流</td>
                <td>nmhuahe</td>
              </tr>
              <tr>
                <td>顺捷丰达</td>
                <td>shunjiefengda</td>
              </tr>
              <tr>
                <td>天马迅达</td>
                <td>tianma</td>
              </tr>
              <tr>
                <td>恒宇运通</td>
                <td>hyytes</td>
              </tr>
              <tr>
                <td>考拉国际速递</td>
                <td>kaolaexpress</td>
              </tr>
              <tr>
                <td>BlueDart</td>
                <td>bluedart</td>
              </tr>
              <tr>
                <td>日日顺快线</td>
                <td>rrskx</td>
              </tr>
              <tr>
                <td>运东西</td>
                <td>yundx</td>
              </tr>
              <tr>
                <td>黑狗物流</td>
                <td>higo</td>
              </tr>
              <tr>
                <td>鹏远国际速递</td>
                <td>pengyuanexpress</td>
              </tr>
              <tr>
                <td>安捷物流</td>
                <td>anjie88</td>
              </tr>
              <tr>
                <td>骏达快递</td>
                <td>jdexpressusa</td>
              </tr>
              <tr>
                <td>C&amp;C国际速递</td>
                <td>cncexp</td>
              </tr>
              <tr>
                <td>北京EMS</td>
                <td>bjemstckj</td>
              </tr>
              <tr>
                <td>airpak expresss</td>
                <td>airpak</td>
              </tr>
              <tr>
                <td>荷兰邮政-中国件</td>
                <td>postnlchina</td>
              </tr>
              <tr>
                <td>大达物流</td>
                <td>idada</td>
              </tr>
              <tr>
                <td>益递物流</td>
                <td>edlogistics</td>
              </tr>
              <tr>
                <td>中外运</td>
                <td>esinotrans</td>
              </tr>
              <tr>
                <td>速派快递(FastGo)</td>
                <td>fastgo</td>
              </tr>
              <tr>
                <td>易客满</td>
                <td>ecmscn</td>
              </tr>
              <tr>
                <td>美国云达</td>
                <td>yundaexus</td>
              </tr>
              <tr>
                <td>Toll</td>
                <td>toll</td>
              </tr>
              <tr>
                <td>深圳DPEX</td>
                <td>szdpex</td>
              </tr>
              <tr>
                <td>俄顺达</td>
                <td>eshunda</td>
              </tr>
              <tr>
                <td>广东速腾物流</td>
                <td>suteng</td>
              </tr>
              <tr>
                <td>新鹏快递</td>
                <td>gdxp</td>
              </tr>
              <tr>
                <td>平安达腾飞</td>
                <td>pingandatengfei</td>
              </tr>
              <tr>
                <td>穗佳物流</td>
                <td>suijiawuliu</td>
              </tr>
              <tr>
                <td>传喜物流</td>
                <td>chuanxiwuliu</td>
              </tr>
              <tr>
                <td>捷特快递</td>
                <td>jietekuaidi</td>
              </tr>
              <tr>
                <td>隆浪快递</td>
                <td>longlangkuaidi</td>
              </tr>
              <tr>
                <td>佳吉快递</td>
                <td>jiajikuaidi</td>
              </tr>
              <tr>
                <td>快达物流</td>
                <td>kuaidawuliu</td>
              </tr>
              <tr>
                <td>飞狐快递</td>
                <td>feihukuaidi</td>
              </tr>
              <tr>
                <td>潇湘晨报</td>
                <td>xiaoxiangchenbao</td>
              </tr>
              <tr>
                <td>巴伦支</td>
                <td>balunzhi</td>
              </tr>
              <tr>
                <td>安能物流</td>
                <td>annengwuliu</td>
              </tr>
              <tr>
                <td>申通快递</td>
                <td>shentong</td>
              </tr>
              <tr>
                <td>亿领速运</td>
                <td>yilingsuyun</td>
              </tr>
              <tr>
                <td>店通快递</td>
                <td>diantongkuaidi</td>
              </tr>
              <tr>
                <td>OCA Argentina</td>
                <td>ocaargen</td>
              </tr>
              <tr>
                <td>尼日利亚(Nigerian Postal)</td>
                <td>nigerianpost</td>
              </tr>
              <tr>
                <td>智利(Correos Chile)</td>
                <td>chile</td>
              </tr>
              <tr>
                <td>以色列(Israel Post)</td>
                <td>israelpost</td>
              </tr>
              <tr>
                <td>京东物流</td>
                <td>jd</td>
              </tr>
              <tr>
                <td>奥地利(Austrian Post)</td>
                <td>austria</td>
              </tr>
              <tr>
                <td>乌克兰小包、大包(UkrPoshta)</td>
                <td>ukraine</td>
              </tr>
              <tr>
                <td>乌干达(Posta Uganda)</td>
                <td>uganda</td>
              </tr>
              <tr>
                <td>阿塞拜疆EMS(EMS AzerExpressPost)</td>
                <td>azerbaijan</td>
              </tr>
              <tr>
                <td>芬兰(Itella Posti Oy)</td>
                <td>finland</td>
              </tr>
              <tr>
                <td>斯洛伐克(Slovenská Posta)</td>
                <td>slovak</td>
              </tr>
              <tr>
                <td>阿鲁巴[荷兰]（Post Aruba）</td>
                <td>aruba</td>
              </tr>
              <tr>
                <td>爱尔兰(An Post)</td>
                <td>ireland</td>
              </tr>
              <tr>
                <td>印度尼西亚EMS(Pos Indonesia-EMS)</td>
                <td>indonesia</td>
              </tr>
              <tr>
                <td>易优包裹</td>
                <td>eupackage</td>
              </tr>
              <tr>
                <td>威时沛运货运</td>
                <td>wtdchina</td>
              </tr>
              <tr>
                <td>行必达</td>
                <td>speeda</td>
              </tr>
              <tr>
                <td>中通国际</td>
                <td>zhongtongguoji</td>
              </tr>
              <tr>
                <td>千顺快递</td>
                <td>qskdyxgs</td>
              </tr>
              <tr>
                <td>西邮寄</td>
                <td>xipost</td>
              </tr>
              <tr>
                <td>顺捷达</td>
                <td>shunjieda</td>
              </tr>
              <tr>
                <td>CE易欧通国际速递</td>
                <td>cloudexpress</td>
              </tr>
              <tr>
                <td>和丰同城</td>
                <td>hfwuxi</td>
              </tr>
              <tr>
                <td>天联快运</td>
                <td>tlky</td>
              </tr>
              <tr>
                <td>优速物流</td>
                <td>youshuwuliu</td>
              </tr>
              <tr>
                <td>埃塞俄比亚(Ethiopian postal)</td>
                <td>ethiopia</td>
              </tr>
              <tr>
                <td>卢森堡(Luxembourg Post)</td>
                <td>luxembourg</td>
              </tr>
              <tr>
                <td>毛里求斯(Mauritius Post)</td>
                <td>mauritius</td>
              </tr>
              <tr>
                <td>文莱(Brunei Postal)</td>
                <td>brunei</td>
              </tr>
              <tr>
                <td>Quantium</td>
                <td>quantium</td>
              </tr>
              <tr>
                <td>中铁物流</td>
                <td>zhongtiewuliu</td>
              </tr>
              <tr>
                <td>宇鑫物流</td>
                <td>yuxinwuliu</td>
              </tr>
              <tr>
                <td>巴林(Bahrain Post)</td>
                <td>bahrain</td>
              </tr>
              <tr>
                <td>纳米比亚(NamPost)</td>
                <td>namibia</td>
              </tr>
              <tr>
                <td>卢旺达(Rwanda i-posita)</td>
                <td>rwanda</td>
              </tr>
              <tr>
                <td>莱索托(Lesotho Post)</td>
                <td>lesotho</td>
              </tr>
              <tr>
                <td>肯尼亚(POSTA KENYA)</td>
                <td>kenya</td>
              </tr>
              <tr>
                <td>喀麦隆(CAMPOST)</td>
                <td>cameroon</td>
              </tr>
              <tr>
                <td>伯利兹(Belize Postal)</td>
                <td>belize</td>
              </tr>
              <tr>
                <td>巴拉圭(Correo Paraguayo)</td>
                <td>paraguay</td>
              </tr>
              <tr>
                <td>波黑(JP BH Posta)</td>
                <td>bohei</td>
              </tr>
              <tr>
                <td>玻利维亚</td>
                <td>bolivia</td>
              </tr>
              <tr>
                <td>柬埔寨(Cambodia Post)</td>
                <td>cambodia</td>
              </tr>
              <tr>
                <td>兰州伙伴物流</td>
                <td>huoban</td>
              </tr>
              <tr>
                <td>天纵物流</td>
                <td>tianzong</td>
              </tr>
              <tr>
                <td>坦桑尼亚(Tanzania Posts)</td>
                <td>tanzania</td>
              </tr>
              <tr>
                <td>阿曼(Oman Post)</td>
                <td>oman</td>
              </tr>
              <tr>
                <td>直布罗陀[英国]( Royal Gibraltar Post)</td>
                <td>gibraltar</td>
              </tr>
              <tr>
                <td>展勤快递</td>
                <td>byht</td>
              </tr>
              <tr>
                <td>越南EMS(VNPost Express)</td>
                <td>vnpost</td>
              </tr>
              <tr>
                <td>安迅物流</td>
                <td>anxl</td>
              </tr>
              <tr>
                <td>达方物流</td>
                <td>dfpost</td>
              </tr>
              <tr>
                <td>十方通物流</td>
                <td>sfift</td>
              </tr>
              <tr>
                <td>飞鹰物流</td>
                <td>hnfy</td>
              </tr>
              <tr>
                <td>UPS i-parcel</td>
                <td>iparcel</td>
              </tr>
              <tr>
                <td>鑫锐达</td>
                <td>bjxsrd</td>
              </tr>
              <tr>
                <td>孟加拉国(EMS)</td>
                <td>bangladesh</td>
              </tr>
              <tr>
                <td>快捷速递</td>
                <td>kuaijiesudi</td>
              </tr>
              <tr>
                <td>日本（Japan Post）</td>
                <td>japanposten</td>
              </tr>
              <tr>
                <td>众辉达物流</td>
                <td>zhdwl</td>
              </tr>
              <tr>
                <td>秦远物流</td>
                <td>qinyuan</td>
              </tr>
              <tr>
                <td>澳邮中国快运</td>
                <td>auexpress</td>
              </tr>
              <tr>
                <td>日益通速递</td>
                <td>rytsd</td>
              </tr>
              <tr>
                <td>航宇快递</td>
                <td>hangyu</td>
              </tr>
              <tr>
                <td>急顺通</td>
                <td>pzhjst</td>
              </tr>
              <tr>
                <td>优速通达</td>
                <td>yousutongda</td>
              </tr>
              <tr>
                <td>飞邦快递</td>
                <td>fbkd</td>
              </tr>
              <tr>
                <td>华达快运</td>
                <td>huada</td>
              </tr>
              <tr>
                <td>FOX国际快递</td>
                <td>fox</td>
              </tr>
              <tr>
                <td>佳怡物流</td>
                <td>jiayiwuliu</td>
              </tr>
              <tr>
                <td>鹏程快递</td>
                <td>pengcheng</td>
              </tr>
              <tr>
                <td>冠庭国际物流</td>
                <td>guanting</td>
              </tr>
              <tr>
                <td>美国快递</td>
                <td>meiguokuaidi</td>
              </tr>
              <tr>
                <td>通和天下</td>
                <td>tonghetianxia</td>
              </tr>
              <tr>
                <td>音素快运</td>
                <td>yinsu</td>
              </tr>
              <tr>
                <td>创一快递</td>
                <td>chuangyi</td>
              </tr>
              <tr>
                <td>重庆星程快递</td>
                <td>cqxingcheng</td>
              </tr>
              <tr>
                <td>贵州星程快递</td>
                <td>gzxingcheng</td>
              </tr>
              <tr>
                <td>河南全速通</td>
                <td>hnqst</td>
              </tr>
              <tr>
                <td>快速递</td>
                <td>ksudi</td>
              </tr>
              <tr>
                <td>北极星快运</td>
                <td>polarisexpress</td>
              </tr>
              <tr>
                <td>6LS EXPRESS</td>
                <td>lsexpress</td>
              </tr>
              <tr>
                <td>ANTS EXPRESS</td>
                <td>qdants</td>
              </tr>
              <tr>
                <td>S2C</td>
                <td>s2c</td>
              </tr>
              <tr>
                <td>Hi淘易快递</td>
                <td>hitaoe</td>
              </tr>
              <tr>
                <td>CNAIR</td>
                <td>cnair</td>
              </tr>
              <tr>
                <td>易欧洲国际物流</td>
                <td>yiouzhou</td>
              </tr>
              <tr>
                <td>阳光快递</td>
                <td>shiningexpress</td>
              </tr>
              <tr>
                <td>北京丰越供应链</td>
                <td>beijingfengyue</td>
              </tr>
              <tr>
                <td>华中快递</td>
                <td>cpsair</td>
              </tr>
              <tr>
                <td>青旅物流</td>
                <td>zqlwl</td>
              </tr>
              <tr>
                <td>易航物流</td>
                <td>yihangmall</td>
              </tr>
              <tr>
                <td>城铁速递</td>
                <td>cex</td>
              </tr>
              <tr>
                <td>千里速递</td>
                <td>qianli</td>
              </tr>
              <tr>
                <td>急递</td>
                <td>jdpplus</td>
              </tr>
              <tr>
                <td>佳捷翔物流</td>
                <td>jjx888</td>
              </tr>
              <tr>
                <td>洋口岸</td>
                <td>ykouan</td>
              </tr>
              <tr>
                <td>考拉速递</td>
                <td>koalaexp</td>
              </tr>
              <tr>
                <td>天越物流</td>
                <td>surpassgo</td>
              </tr>
              <tr>
                <td>邮政标准快递</td>
                <td>youzhengbk</td>
              </tr>
              <tr>
                <td>运通快运</td>
                <td>ytky168</td>
              </tr>
              <tr>
                <td>卢森堡航空</td>
                <td>cargolux</td>
              </tr>
              <tr>
                <td>优优速递</td>
                <td>youyou</td>
              </tr>
              <tr>
                <td>全川物流</td>
                <td>quanchuan56</td>
              </tr>
              <tr>
                <td>SYNSHIP快递</td>
                <td>synship</td>
              </tr>
              <tr>
                <td>仓鼠快递</td>
                <td>cangspeed</td>
              </tr>
              <tr>
                <td>递五方云仓</td>
                <td>di5pll</td>
              </tr>
              <tr>
                <td>卓志速运</td>
                <td>chinaicip</td>
              </tr>
              <tr>
                <td>闪电兔</td>
                <td>shandiantu</td>
              </tr>
              <tr>
                <td>新宁物流</td>
                <td>xinning</td>
              </tr>
              <tr>
                <td>春风物流</td>
                <td>spring56</td>
              </tr>
              <tr>
                <td>首达速运</td>
                <td>sdsy888</td>
              </tr>
              <tr>
                <td>丽狮物流</td>
                <td>lishi</td>
              </tr>
              <tr>
                <td>雅澳物流</td>
                <td>yourscm</td>
              </tr>
              <tr>
                <td>直德邮</td>
                <td>zdepost</td>
              </tr>
              <tr>
                <td>日昱物流</td>
                <td>riyuwuliu</td>
              </tr>
              <tr>
                <td>Gati-中文</td>
                <td>gaticn</td>
              </tr>
              <tr>
                <td>派尔快递</td>
                <td>peex</td>
              </tr>
              <tr>
                <td>汇文</td>
                <td>huiwen</td>
              </tr>
              <tr>
                <td>东红物流</td>
                <td>donghong</td>
              </tr>
              <tr>
                <td>增益速递</td>
                <td>zengyisudi</td>
              </tr>
              <tr>
                <td>好运来</td>
                <td>hlyex</td>
              </tr>
              <tr>
                <td>顺丰速运</td>
                <td>shunfeng</td>
              </tr>
              <tr>
                <td>城际快递</td>
                <td>chengji</td>
              </tr>
              <tr>
                <td>程光快递</td>
                <td>chengguangkuaidi</td>
              </tr>
              <tr>
                <td>天翼快递</td>
                <td>tykd</td>
              </tr>
              <tr>
                <td>京东订单</td>
                <td>jdorder</td>
              </tr>
              <tr>
                <td>蓝天快递</td>
                <td>lantiankuaidi</td>
              </tr>
              <tr>
                <td>永昌物流</td>
                <td>yongchangwuliu</td>
              </tr>
              <tr>
                <td>笨鸟海淘</td>
                <td>birdex</td>
              </tr>
              <tr>
                <td>一正达速运</td>
                <td>yizhengdasuyun</td>
              </tr>
              <tr>
                <td>德意思</td>
                <td>dabei</td>
              </tr>
              <tr>
                <td>佐川急便</td>
                <td>sagawa</td>
              </tr>
              <tr>
                <td>优配速运</td>
                <td>sdyoupei</td>
              </tr>
              <tr>
                <td>速必达</td>
                <td>subida</td>
              </tr>
              <tr>
                <td>景光物流</td>
                <td>jgwl</td>
              </tr>
              <tr>
                <td>御风速运</td>
                <td>yufeng</td>
              </tr>
              <tr>
                <td>至诚通达快递</td>
                <td>zhichengtongda</td>
              </tr>
              <tr>
                <td>特急便物流</td>
                <td>sucmj</td>
              </tr>
              <tr>
                <td>亚马逊中国</td>
                <td>yamaxunwuliu</td>
              </tr>
              <tr>
                <td>货运皇</td>
                <td>kingfreight</td>
              </tr>
              <tr>
                <td>锦程物流</td>
                <td>jinchengwuliu</td>
              </tr>
              <tr>
                <td>澳货通</td>
                <td>auex</td>
              </tr>
              <tr>
                <td>澳速物流</td>
                <td>aosu</td>
              </tr>
              <tr>
                <td>澳世速递</td>
                <td>aus</td>
              </tr>
              <tr>
                <td>环球速运</td>
                <td>huanqiu</td>
              </tr>
              <tr>
                <td>麦力快递</td>
                <td>mailikuaidi</td>
              </tr>
              <tr>
                <td>瑞丰速递</td>
                <td>rfsd</td>
              </tr>
              <tr>
                <td>美联快递</td>
                <td>letseml</td>
              </tr>
              <tr>
                <td>CNPEX中邮快递</td>
                <td>cnpex</td>
              </tr>
              <tr>
                <td>鑫世锐达</td>
                <td>xsrd</td>
              </tr>
              <tr>
                <td>顺丰优选</td>
                <td>sfbest</td>
              </tr>
              <tr>
                <td>全峰快递</td>
                <td>quanfengkuaidi</td>
              </tr>
              <tr>
                <td>克罗地亚（Hrvatska Posta）</td>
                <td>hrvatska</td>
              </tr>
              <tr>
                <td>保加利亚（Bulgarian Posts）</td>
                <td>bulgarian</td>
              </tr>
              <tr>
                <td>Portugal Seur</td>
                <td>portugalseur</td>
              </tr>
              <tr>
                <td>International Seur</td>
                <td>seur</td>
              </tr>
              <tr>
                <td>久易快递</td>
                <td>jiuyicn</td>
              </tr>
              <tr>
                <td>Direct Link</td>
                <td>directlink</td>
              </tr>
              <tr>
                <td>希腊EMS（ELTA Courier）</td>
                <td>eltahell</td>
              </tr>
              <tr>
                <td>捷克（?eská po?ta）</td>
                <td>ceskaposta</td>
              </tr>
              <tr>
                <td>Siodemka</td>
                <td>siodemka</td>
              </tr>
              <tr>
                <td>爱尔兰(An Post)</td>
                <td>anposten</td>
              </tr>
              <tr>
                <td>渥途国际速运</td>
                <td>wotu</td>
              </tr>
              <tr>
                <td>一号线</td>
                <td>lineone</td>
              </tr>
              <tr>
                <td>四海快递</td>
                <td>sihaiet</td>
              </tr>
              <tr>
                <td>德坤物流</td>
                <td>dekuncn</td>
              </tr>
              <tr>
                <td>准实快运</td>
                <td>zsky123</td>
              </tr>
              <tr>
                <td>宏捷国际物流</td>
                <td>hongjie</td>
              </tr>
              <tr>
                <td>鸿讯物流</td>
                <td>hongxun</td>
              </tr>
              <tr>
                <td>卡邦配送</td>
                <td>ahkbps</td>
              </tr>
              <tr>
                <td>凡客配送（作废）</td>
                <td>vancl</td>
              </tr>
              <tr>
                <td>瑞士邮政</td>
                <td>swisspostcn</td>
              </tr>
              <tr>
                <td>辉联物流</td>
                <td>huilian</td>
              </tr>
              <tr>
                <td>A2U速递</td>
                <td>a2u</td>
              </tr>
              <tr>
                <td>UEQ快递</td>
                <td>ueq</td>
              </tr>
              <tr>
                <td>中加国际快递</td>
                <td>scic</td>
              </tr>
              <tr>
                <td>易达通</td>
                <td>yidatong</td>
              </tr>
              <tr>
                <td>宜送</td>
                <td>yisong</td>
              </tr>
              <tr>
                <td>全球快运</td>
                <td>abcglobal</td>
              </tr>
              <tr>
                <td>芒果速递</td>
                <td>mangguo</td>
              </tr>
              <tr>
                <td>金海淘</td>
                <td>goldhaitao</td>
              </tr>
              <tr>
                <td>极光转运</td>
                <td>jiguang</td>
              </tr>
              <tr>
                <td>富腾达国际货运</td>
                <td>ftd</td>
              </tr>
              <tr>
                <td>DCS</td>
                <td>dcs</td>
              </tr>
              <tr>
                <td>捷网俄全通</td>
                <td>ruexp</td>
              </tr>
              <tr>
                <td>华通务达物流</td>
                <td>htwd</td>
              </tr>
              <tr>
                <td>申必达</td>
                <td>speedoex</td>
              </tr>
              <tr>
                <td>联运快递</td>
                <td>lianyun</td>
              </tr>
              <tr>
                <td>捷安达</td>
                <td>jieanda</td>
              </tr>
              <tr>
                <td>SHL畅灵国际物流</td>
                <td>shlexp</td>
              </tr>
              <tr>
                <td>EWE全球快递</td>
                <td>ewe</td>
              </tr>
              <tr>
                <td>顺邦国际物流</td>
                <td>shunbang</td>
              </tr>
              <tr>
                <td>成达国际速递</td>
                <td>chengda</td>
              </tr>
              <tr>
                <td>启辰国际速递</td>
                <td>qichen</td>
              </tr>
              <tr>
                <td>合众速递(UCS）</td>
                <td>ucs</td>
              </tr>
              <tr>
                <td>阿富汗(Afghan Post)</td>
                <td>afghan</td>
              </tr>
              <tr>
                <td>白俄罗斯(Belpochta)</td>
                <td>belpost</td>
              </tr>
              <tr>
                <td>冠捷物流</td>
                <td>gjwl</td>
              </tr>
              <tr>
                <td>钏博物流</td>
                <td>cbo56</td>
              </tr>
              <tr>
                <td>西翼物流</td>
                <td>westwing</td>
              </tr>
              <tr>
                <td>优邦速运</td>
                <td>ubonex</td>
              </tr>
              <tr>
                <td>首通快运</td>
                <td>staky</td>
              </tr>
              <tr>
                <td>马珂博逻</td>
                <td>cnmcpl</td>
              </tr>
              <tr>
                <td>小熊物流</td>
                <td>littlebearbear</td>
              </tr>
              <tr>
                <td>玥玛速运</td>
                <td>yue777</td>
              </tr>
              <tr>
                <td>上海航瑞货运</td>
                <td>hangrui</td>
              </tr>
              <tr>
                <td>星云速递</td>
                <td>nebuex</td>
              </tr>
              <tr>
                <td>环创物流</td>
                <td>ghl</td>
              </tr>
              <tr>
                <td>林安物流</td>
                <td>lasy56</td>
              </tr>
              <tr>
                <td>笨鸟国际</td>
                <td>benniao</td>
              </tr>
              <tr>
                <td>全速快递</td>
                <td>fsexp</td>
              </tr>
              <tr>
                <td>法翔速运</td>
                <td>ftlexpress</td>
              </tr>
              <tr>
                <td>易转运</td>
                <td>ezhuanyuan</td>
              </tr>
              <tr>
                <td>Superb Grace</td>
                <td>superb</td>
              </tr>
              <tr>
                <td>蓝天国际快递</td>
                <td>ltx</td>
              </tr>
              <tr>
                <td>圣飞捷快递</td>
                <td>sfjhd</td>
              </tr>
              <tr>
                <td>淘韩国际快递</td>
                <td>krtao</td>
              </tr>
              <tr>
                <td>容智快运</td>
                <td>gdrz58</td>
              </tr>
              <tr>
                <td>锦程快递</td>
                <td>hrex</td>
              </tr>
              <tr>
                <td>顺时达物流</td>
                <td>hnssd56</td>
              </tr>
              <tr>
                <td>骏绅物流</td>
                <td>jsexpress</td>
              </tr>
              <tr>
                <td>德国雄鹰速递</td>
                <td>adlerlogi</td>
              </tr>
              <tr>
                <td>远为快递</td>
                <td>ywexpress</td>
              </tr>
              <tr>
                <td>嗖一下同城快递</td>
                <td>sofast56</td>
              </tr>
              <tr>
                <td>开心快递</td>
                <td>happylink</td>
              </tr>
              <tr>
                <td>五六快运</td>
                <td>wuliuky</td>
              </tr>
              <tr>
                <td>卓烨快递</td>
                <td>hrbzykd</td>
              </tr>
              <tr>
                <td>ZTE中兴物流</td>
                <td>zteexpress</td>
              </tr>
              <tr>
                <td>尼尔快递</td>
                <td>nell</td>
              </tr>
              <tr>
                <td>高铁快运</td>
                <td>gaotieex</td>
              </tr>
              <tr>
                <td>万家康物流</td>
                <td>wjkwl</td>
              </tr>
              <tr>
                <td>国晶物流</td>
                <td>xdshipping</td>
              </tr>
              <tr>
                <td>德国云快递</td>
                <td>yunexpress</td>
              </tr>
              <tr>
                <td>宏递快运</td>
                <td>hd</td>
              </tr>
              <tr>
                <td>一起送</td>
                <td>yiqisong</td>
              </tr>
              <tr>
                <td>迈隆递运</td>
                <td>mailongdy</td>
              </tr>
              <tr>
                <td>新亚物流</td>
                <td>nalexpress</td>
              </tr>
              <tr>
                <td>艾瑞斯远</td>
                <td>ariesfar</td>
              </tr>
              <tr>
                <td>澳多多国际速递</td>
                <td>adodoxm</td>
              </tr>
              <tr>
                <td>CNUP 中联邮</td>
                <td>cnup</td>
              </tr>
              <tr>
                <td>UEX国际物流</td>
                <td>uex</td>
              </tr>
              <tr>
                <td>Hermes</td>
                <td>hermes</td>
              </tr>
              <tr>
                <td>PostElbe</td>
                <td>postelbe</td>
              </tr>
              <tr>
                <td>维普恩物流</td>
                <td>vps</td>
              </tr>
              <tr>
                <td>明辉物流</td>
                <td>zsmhwl</td>
              </tr>
              <tr>
                <td>联运通物流</td>
                <td>szuem</td>
              </tr>
              <tr>
                <td>龙象国际物流</td>
                <td>edragon</td>
              </tr>
              <tr>
                <td>永邦国际物流</td>
                <td>yongbangwuliu</td>
              </tr>
              <tr>
                <td>51跨境通</td>
                <td>wykjt</td>
              </tr>
              <tr>
                <td>速配欧翼</td>
                <td>superoz</td>
              </tr>
              <tr>
                <td>嘉里大荣物流</td>
                <td>kerrytj</td>
              </tr>
              <tr>
                <td>中国香港环球快运</td>
                <td>huanqiuabc</td>
              </tr>
              <tr>
                <td>CL日中速运</td>
                <td>clsp</td>
              </tr>
              <tr>
                <td>SQK国际速递</td>
                <td>chinasqk</td>
              </tr>
              <tr>
                <td>家家通快递</td>
                <td>newsway</td>
              </tr>
              <tr>
                <td>邮客全球速递</td>
                <td>yyox</td>
              </tr>
              <tr>
                <td>华瀚快递</td>
                <td>hhair56</td>
              </tr>
              <tr>
                <td>顺士达速运</td>
                <td>shunshid</td>
              </tr>
              <tr>
                <td>天翔东捷运</td>
                <td>djy56</td>
              </tr>
              <tr>
                <td>卓实快运</td>
                <td>zhuoshikuaiyun</td>
              </tr>
              <tr>
                <td>吉祥邮（澳洲）</td>
                <td>jixiangyouau</td>
              </tr>
              <tr>
                <td>蓝天快递</td>
                <td>blueskyexpress</td>
              </tr>
              <tr>
                <td>天天快物流</td>
                <td>guoeryue</td>
              </tr>
              <tr>
                <td>纵通速运</td>
                <td>ynztsy</td>
              </tr>
              <tr>
                <td>中通快运</td>
                <td>zhongtongkuaiyun</td>
              </tr>
              <tr>
                <td>CNE</td>
                <td>cnexps</td>
              </tr>
              <tr>
                <td>希腊包裹（ELTA Hellenic Post）</td>
                <td>elta</td>
              </tr>
              <tr>
                <td>星速递</td>
                <td>starex</td>
              </tr>
              <tr>
                <td>土耳其</td>
                <td>ptt</td>
              </tr>
              <tr>
                <td>哥伦比亚(4-72 La Red Postal de Colombia)</td>
                <td>colombia</td>
              </tr>
              <tr>
                <td>加州猫速递</td>
                <td>jiazhoumao</td>
              </tr>
              <tr>
                <td>捷邦物流</td>
                <td>jieborne</td>
              </tr>
              <tr>
                <td>邮政国内</td>
                <td>yzguonei</td>
              </tr>
              <tr>
                <td>Canpar</td>
                <td>canpar</td>
              </tr>
              <tr>
                <td>海硕高铁速递</td>
                <td>hsgtsd</td>
              </tr>
              <tr>
                <td>日日通国际</td>
                <td>rrthk</td>
              </tr>
              <tr>
                <td>天翼物流</td>
                <td>tywl99</td>
              </tr>
              <tr>
                <td>啪啪供应链</td>
                <td>papascm</td>
              </tr>
              <tr>
                <td>万达美</td>
                <td>wdm</td>
              </tr>
              <tr>
                <td>安得物流</td>
                <td>annto</td>
              </tr>
              <tr>
                <td>广东诚通物流</td>
                <td>gdct56</td>
              </tr>
              <tr>
                <td>安达速递</td>
                <td>adapost</td>
              </tr>
              <tr>
                <td>易达国际速递</td>
                <td>eta100</td>
              </tr>
              <tr>
                <td>西游寄</td>
                <td>xiyoug</td>
              </tr>
              <tr>
                <td>光线速递</td>
                <td>gxwl</td>
              </tr>
              <tr>
                <td>易邮国际</td>
                <td>euguoji</td>
              </tr>
              <tr>
                <td>深圳邮政</td>
                <td>szyouzheng</td>
              </tr>
              <tr>
                <td>粤中国际货运代理（上海）有限公司</td>
                <td>yuezhongsh</td>
              </tr>
              <tr>
                <td>城通物流</td>
                <td>chengtong</td>
              </tr>
              <tr>
                <td>GE2D跨境物流</td>
                <td>ge2d</td>
              </tr>
              <tr>
                <td>败欧洲</td>
                <td>europe8</td>
              </tr>
              <tr>
                <td>飛斯特</td>
                <td>bester</td>
              </tr>
              <tr>
                <td>蒙古国(Mongol Post)</td>
                <td>mongolpost</td>
              </tr>
              <tr>
                <td>乌拉圭（Correo Uruguayo）</td>
                <td>correo</td>
              </tr>
              <tr>
                <td>牙买加（Jamaica Post）</td>
                <td>jamaicapost</td>
              </tr>
              <tr>
                <td>格鲁吉亚(Georgian Pos）</td>
                <td>georgianpost</td>
              </tr>
              <tr>
                <td>美达快递</td>
                <td>meidaexpress</td>
              </tr>
              <tr>
                <td>驭丰速运</td>
                <td>yfsuyun</td>
              </tr>
              <tr>
                <td>无忧物流</td>
                <td>aliexpress</td>
              </tr>
              <tr>
                <td>邮鸽速运</td>
                <td>ugoexpress</td>
              </tr>
              <tr>
                <td>澳洲新干线快递</td>
                <td>expressplus</td>
              </tr>
              <tr>
                <td>标杆物流</td>
                <td>bmlchina</td>
              </tr>
              <tr>
                <td>长风物流</td>
                <td>longvast</td>
              </tr>
              <tr>
                <td>邮来速递</td>
                <td>youlai</td>
              </tr>
              <tr>
                <td>魔速达</td>
                <td>mosuda</td>
              </tr>
              <tr>
                <td>商桥物流</td>
                <td>shangqiao56</td>
              </tr>
              <tr>
                <td>AUV国际快递</td>
                <td>auvexpress</td>
              </tr>
              <tr>
                <td>Newgistics</td>
                <td>newgistics</td>
              </tr>
              <tr>
                <td>FQ狂派速递</td>
                <td>freakyquick</td>
              </tr>
              <tr>
                <td>泽西岛</td>
                <td>jerseypost</td>
              </tr>
              <tr>
                <td>威盛快递</td>
                <td>wherexpess</td>
              </tr>
              <tr>
                <td>运通速运</td>
                <td>yuntong</td>
              </tr>
              <tr>
                <td>老挝(Lao Express)</td>
                <td>lao</td>
              </tr>
              <tr>
                <td>巴布亚新几内亚(PNG Post)</td>
                <td>postpng</td>
              </tr>
              <tr>
                <td>EASY EXPRESS</td>
                <td>easyexpress</td>
              </tr>
              <tr>
                <td>壹米滴答</td>
                <td>yimidida</td>
              </tr>
              <tr>
                <td>飞云快递系统</td>
                <td>fyex</td>
              </tr>
              <tr>
                <td>跨跃国际</td>
                <td>kyue</td>
              </tr>
              <tr>
                <td>EMS包裹</td>
                <td>emsbg</td>
              </tr>
              <tr>
                <td>珠峰速运</td>
                <td>zf365</td>
              </tr>
              <tr>
                <td>甘肃安的快递</td>
                <td>gansuandi</td>
              </tr>
              <tr>
                <td>一辉物流</td>
                <td>yatfai</td>
              </tr>
              <tr>
                <td>e直运</td>
                <td>edtexpress</td>
              </tr>
              <tr>
                <td>wish邮</td>
                <td>shpostwish</td>
              </tr>
              <tr>
                <td>顶世国际物流</td>
                <td>topshey</td>
              </tr>
              <tr>
                <td>龙枫国际快递</td>
                <td>lfexpress</td>
              </tr>
              <tr>
                <td>安能快递</td>
                <td>ane66</td>
              </tr>
              <tr>
                <td>圆通快运</td>
                <td>yuantongkuaiyun</td>
              </tr>
              <tr>
                <td>宝通快递</td>
                <td>baotongkd</td>
              </tr>
              <tr>
                <td>美国汉邦快递</td>
                <td>aplus100</td>
              </tr>
              <tr>
                <td>易普递</td>
                <td>sixroad</td>
              </tr>
              <tr>
                <td>速呈</td>
                <td>sczpds</td>
              </tr>
              <tr>
                <td>海淘物流</td>
                <td>ht22</td>
              </tr>
              <tr>
                <td>海米派物流</td>
                <td>haimibuy</td>
              </tr>
              <tr>
                <td>天翔快递</td>
                <td>tianxiang</td>
              </tr>
              <tr>
                <td>易境达国际物流</td>
                <td>uscbexpress</td>
              </tr>
              <tr>
                <td>大韩通运</td>
                <td>cjkoreaexpress</td>
              </tr>
              <tr>
                <td>澳世速递</td>
                <td>ausexpress</td>
              </tr>
              <tr>
                <td>未来明天快递</td>
                <td>weilaimingtian</td>
              </tr>
              <tr>
                <td>科捷物流</td>
                <td>kejie</td>
              </tr>
              <tr>
                <td>大道物流</td>
                <td>dadaoex</td>
              </tr>
              <tr>
                <td>全联速运</td>
                <td>guexp</td>
              </tr>
              <tr>
                <td>可可树美中速运</td>
                <td>excocotree</td>
              </tr>
              <tr>
                <td>邮邦国际</td>
                <td>youban</td>
              </tr>
              <tr>
                <td>西安运逸快递</td>
                <td>yyexp</td>
              </tr>
              <tr>
                <td>Aplus物流</td>
                <td>aplusex</td>
              </tr>
              <tr>
                <td>锋鸟物流</td>
                <td>beebird</td>
              </tr>
              <tr>
                <td>青云物流</td>
                <td>bjqywl</td>
              </tr>
              <tr>
                <td>万邑通</td>
                <td>winit</td>
              </tr>
              <tr>
                <td>中翼国际物流</td>
                <td>chnexp</td>
              </tr>
              <tr>
                <td>亚洲顺物流</td>
                <td>yzswuliu</td>
              </tr>
              <tr>
                <td>E跨通</td>
                <td>ecallturn</td>
              </tr>
              <tr>
                <td>递四方美国</td>
                <td>disifangus</td>
              </tr>
              <tr>
                <td>星空国际</td>
                <td>wlwex</td>
              </tr>
              <tr>
                <td>极地快递</td>
                <td>polarexpress</td>
              </tr>
              <tr>
                <td>到了港</td>
                <td>camekong</td>
              </tr>
              <tr>
                <td>斯里兰卡(Sri Lanka Post)</td>
                <td>slpost</td>
              </tr>
              <tr>
                <td>斯洛文尼亚(Slovenia Post)</td>
                <td>slovenia</td>
              </tr>
              <tr>
                <td>多米尼加（INPOSDOM – Instituto Postal Dominicano）</td>
                <td>inposdom</td>
              </tr>
              <tr>
                <td>星运快递</td>
                <td>staryvr</td>
              </tr>
              <tr>
                <td>狮爱高铁物流</td>
                <td>sycawl</td>
              </tr>
              <tr>
                <td>爱拜物流</td>
                <td>ibuy8</td>
              </tr>
              <tr>
                <td>商海德物流</td>
                <td>shd56</td>
              </tr>
              <tr>
                <td>九宫物流</td>
                <td>jiugong</td>
              </tr>
              <tr>
                <td>缔惠盛合</td>
                <td>twkd56</td>
              </tr>
              <tr>
                <td>快服务</td>
                <td>kfwnet</td>
              </tr>
              <tr>
                <td>dhl小包</td>
                <td>dhlecommerce</td>
              </tr>
              <tr>
                <td>宇佳物流</td>
                <td>yujiawl</td>
              </tr>
              <tr>
                <td>湘达物流</td>
                <td>xiangdawuliu</td>
              </tr>
              <tr>
                <td>远盾物流</td>
                <td>yuandun</td>
              </tr>
              <tr>
                <td>黑猫宅急便</td>
                <td>tcat</td>
              </tr>
              <tr>
                <td>韵达快运</td>
                <td>yundakuaiyun</td>
              </tr>
              <tr>
                <td>速派快递</td>
                <td>fastgoexpress</td>
              </tr>
              <tr>
                <td>中集冷云</td>
                <td>cccc58</td>
              </tr>
              <tr>
                <td>久久物流</td>
                <td>jiujiuwl</td>
              </tr>
              <tr>
                <td>德国八易转运</td>
                <td>deguo8elog</td>
              </tr>
              <tr>
                <td>UTAO优到</td>
                <td>utaoscm</td>
              </tr>
              <tr>
                <td>乾坤物流</td>
                <td>yatexpress</td>
              </tr>
              <tr>
                <td>摩洛哥 ( Morocco Post )</td>
                <td>morocco</td>
              </tr>
              <tr>
                <td>尼泊尔（Nepal Postal Services）</td>
                <td>nepalpost</td>
              </tr>
              <tr>
                <td>伊朗（Iran Post）</td>
                <td>iran</td>
              </tr>
              <tr>
                <td>坦桑尼亚（Tanzania Posts Corporation）</td>
                <td>posta</td>
              </tr>
              <tr>
                <td>莫桑比克（Correios de Moçambique）</td>
                <td>correios</td>
              </tr>
              <tr>
                <td>聚中大</td>
                <td>juzhongda</td>
              </tr>
              <tr>
                <td>中邮电商</td>
                <td>chinapostcb</td>
              </tr>
              <tr>
                <td>鸿泰物流</td>
                <td>hnht56</td>
              </tr>
              <tr>
                <td>南非EMS</td>
                <td>emssouthafrica</td>
              </tr>
              <tr>
                <td>申通国际</td>
                <td>stosolution</td>
              </tr>
              <tr>
                <td>皮牙子快递</td>
                <td>bazirim</td>
              </tr>
              <tr>
                <td>联众国际</td>
                <td>epspost</td>
              </tr>
              <tr>
                <td>丰通快运</td>
                <td>ftky365</td>
              </tr>
              <tr>
                <td>BorderGuru</td>
                <td>borderguru</td>
              </tr>
              <tr>
                <td>艾姆勒</td>
                <td>imlb2c</td>
              </tr>
              <tr>
                <td>中欧国际物流</td>
                <td>eucnrail</td>
              </tr>
              <tr>
                <td>递四方澳洲</td>
                <td>disifangau</td>
              </tr>
              <tr>
                <td>艺凡快递</td>
                <td>yifankd</td>
              </tr>
              <tr>
                <td>宏观国际快递</td>
                <td>gvpexpress</td>
              </tr>
              <tr>
                <td>博茨瓦纳</td>
                <td>botspost</td>
              </tr>
              <tr>
                <td>塞内加尔</td>
                <td>laposte</td>
              </tr>
              <tr>
                <td>卡塔尔（Qatar Post）</td>
                <td>qpost</td>
              </tr>
              <tr>
                <td>苏丹（Sudapost）</td>
                <td>sudapost</td>
              </tr>
              <tr>
                <td>Sureline冠泰</td>
                <td>sureline</td>
              </tr>
              <tr>
                <td>海沧无忧</td>
                <td>hivewms</td>
              </tr>
              <tr>
                <td>安世通快递</td>
                <td>astexpress</td>
              </tr>
              <tr>
                <td>集先锋快递</td>
                <td>jxfex</td>
              </tr>
              <tr>
                <td>丰客物流</td>
                <td>fecobv</td>
              </tr>
              <tr>
                <td>同城快寄</td>
                <td>shpost</td>
              </tr>
              <tr>
                <td>海联快递</td>
                <td>hltop</td>
              </tr>
              <tr>
                <td>中联速递</td>
                <td>auvanda</td>
              </tr>
              <tr>
                <td>三象速递</td>
                <td>sxexpress</td>
              </tr>
              <tr>
                <td>神马快递</td>
                <td>shenma</td>
              </tr>
              <tr>
                <td>互联快运</td>
                <td>hlkytj</td>
              </tr>
              <tr>
                <td>温通物流</td>
                <td>wto56kj</td>
              </tr>
              <tr>
                <td>四海捷运</td>
                <td>sihiexpress</td>
              </tr>
              <tr>
                <td>苏通快运</td>
                <td>zjstky</td>
              </tr>
              <tr>
                <td>邦通国际</td>
                <td>comexpress</td>
              </tr>
              <tr>
                <td>劲通快递</td>
                <td>jintongkd</td>
              </tr>
              <tr>
                <td>凡仕特物流</td>
                <td>wlfast</td>
              </tr>
              <tr>
                <td>红背心</td>
                <td>hongbeixin</td>
              </tr>
              <tr>
                <td>居家通</td>
                <td>homexpress</td>
              </tr>
              <tr>
                <td>上大物流</td>
                <td>shangda</td>
              </tr>
              <tr>
                <td>中邮物流</td>
                <td>zhongyouwuliu</td>
              </tr>
              <tr>
                <td>Fedex-国际件-中文</td>
                <td>fedexcn</td>
              </tr>
              <tr>
                <td>韩国（Korea Post）</td>
                <td>koreapost</td>
              </tr>
              <tr>
                <td>中通快递</td>
                <td>zhongtong</td>
              </tr>
              <tr>
                <td>京广速递</td>
                <td>jinguangsudikuaijian</td>
              </tr>
              <tr>
                <td>FedEx-国际件</td>
                <td>fedex</td>
              </tr>
              <tr>
                <td>日日顺物流</td>
                <td>rrs</td>
              </tr>
              <tr>
                <td>微店</td>
                <td>weidianorder</td>
              </tr>
              <tr>
                <td>当当</td>
                <td>dangdangorder</td>
              </tr>
              <tr>
                <td>国送快运</td>
                <td>guosong</td>
              </tr>
              <tr>
                <td>考拉订单</td>
                <td>kaolaorder</td>
              </tr>
              <tr>
                <td>AAE-中国件</td>
                <td>aae</td>
              </tr>
              <tr>
                <td>四川快优达速递</td>
                <td>kuaiyouda</td>
              </tr>
              <tr>
                <td>百福东方</td>
                <td>baifudongfang</td>
              </tr>
              <tr>
                <td>TST速运通</td>
                <td>tstexp</td>
              </tr>
              <tr>
                <td>YUN TRACK</td>
                <td>yuntrack</td>
              </tr>
              <tr>
                <td>招金精炼</td>
                <td>zhaojin</td>
              </tr>
              <tr>
                <td>全程快递</td>
                <td>agopost</td>
              </tr>
              <tr>
                <td>CDEK</td>
                <td>cdek</td>
              </tr>
              <tr>
                <td>签收快递</td>
                <td>signedexpress</td>
              </tr>
              <tr>
                <td>佰麒快递</td>
                <td>beckygo</td>
              </tr>
              <tr>
                <td>增速跨境</td>
                <td>zyzoom</td>
              </tr>
              <tr>
                <td>Aramex</td>
                <td>aramex</td>
              </tr>
              <tr>
                <td>越中国际物流</td>
                <td>vctrans</td>
              </tr>
              <tr>
                <td>德国优拜物流</td>
                <td>ubuy</td>
              </tr>
              <tr>
                <td>德尚国际速递</td>
                <td>gslexpress</td>
              </tr>
              <tr>
                <td>德国 EUC POST</td>
                <td>eucpost</td>
              </tr>
              <tr>
                <td>泰国中通ZTO</td>
                <td>thaizto</td>
              </tr>
              <tr>
                <td>泰国中通CTO</td>
                <td>ctoexp</td>
              </tr>
              <tr>
                <td>顺丰-繁体</td>
                <td>shunfenghk</td>
              </tr>
              <tr>
                <td>嘉诚速达</td>
                <td>jcsuda</td>
              </tr>
              <tr>
                <td>AFL</td>
                <td>afl</td>
              </tr>
              <tr>
                <td>众派速递</td>
                <td>zhpex</td>
              </tr>
              <tr>
                <td>海星桥快递</td>
                <td>haixingqiao</td>
              </tr>
              <tr>
                <td>蘑菇街</td>
                <td>mogujieorder</td>
              </tr>
              <tr>
                <td>嘉里大通</td>
                <td>jialidatong</td>
              </tr>
              <tr>
                <td>万象物流</td>
                <td>wanxiangwuliu</td>
              </tr>
              <tr>
                <td>澳大利亚(Australia Post)</td>
                <td>auspost</td>
              </tr>
              <tr>
                <td>国通快递</td>
                <td>guotongkuaidi</td>
              </tr>
              <tr>
                <td>全晨快递</td>
                <td>quanchenkuaidi</td>
              </tr>
              <tr>
                <td>飞豹快递</td>
                <td>feibaokuaidi</td>
              </tr>
              <tr>
                <td>中速快递</td>
                <td>zhongsukuaidi</td>
              </tr>
              <tr>
                <td>优能物流</td>
                <td>mantoo</td>
              </tr>
              <tr>
                <td>国美</td>
                <td>gomeorder</td>
              </tr>
              <tr>
                <td>亚马逊中国订单</td>
                <td>amazoncnorder</td>
              </tr>
              <tr>
                <td>蜜芽订单</td>
                <td>miaorder</td>
              </tr>
              <tr>
                <td>顺丰订单</td>
                <td>sfexpressorder</td>
              </tr>
              <tr>
                <td>申通快运</td>
                <td>stoe56</td>
              </tr>
              <tr>
                <td>City-Link</td>
                <td>citylink</td>
              </tr>
              <tr>
                <td>德邦物流</td>
                <td>debangwuliu</td>
              </tr>
              <tr>
                <td>银捷速递</td>
                <td>yinjiesudi</td>
              </tr>
              <tr>
                <td>D速快递</td>
                <td>dsukuaidi</td>
              </tr>
              <tr>
                <td>民邦速递</td>
                <td>minbangsudi</td>
              </tr>
              <tr>
                <td>百世快运</td>
                <td>baishiwuliu</td>
              </tr>
              <tr>
                <td>DHL-德国件（DHL Deutschland）</td>
                <td>dhlde</td>
              </tr>
              <tr>
                <td>能装能送</td>
                <td>canhold</td>
              </tr>
              <tr>
                <td>聚美优品</td>
                <td>jumeiyoupinorder</td>
              </tr>
              <tr>
                <td>诚一物流</td>
                <td>parcelchina</td>
              </tr>
              <tr>
                <td>网易严选</td>
                <td>wangyiyxorder</td>
              </tr>
              <tr>
                <td>龙邦速递</td>
                <td>longbanwuliu</td>
              </tr>
              <tr>
                <td>明亮物流</td>
                <td>mingliangwuliu</td>
              </tr>
              <tr>
                <td>速尔快递</td>
                <td>suer</td>
              </tr>
              <tr>
                <td>盛辉物流</td>
                <td>shenghuiwuliu</td>
              </tr>
              <tr>
                <td>越丰物流</td>
                <td>yuefengwuliu</td>
              </tr>
              <tr>
                <td>比利时（Bpost）</td>
                <td>bpost</td>
              </tr>
              <tr>
                <td>韵达快递</td>
                <td>yunda</td>
              </tr>
              <tr>
                <td>唯品会</td>
                <td>vipshoporder</td>
              </tr>
              <tr>
                <td>美丽说</td>
                <td>meilishuoorder</td>
              </tr>
              <tr>
                <td>顺丰优选</td>
                <td>sfbestorder</td>
              </tr>
              <tr>
                <td>驼峰国际</td>
                <td>humpline</td>
              </tr>
              <tr>
                <td>小米订单</td>
                <td>xiaomiorder</td>
              </tr>
              <tr>
                <td>一智通</td>
                <td>1ziton</td>
              </tr>
              <tr>
                <td>TransRush</td>
                <td>transrush</td>
              </tr>
              <tr>
                <td>百世快递</td>
                <td>huitongkuaidi</td>
              </tr>
              <tr>
                <td>联昊通</td>
                <td>lianhaowuliu</td>
              </tr>
              <tr>
                <td>远成物流</td>
                <td>yuanchengwuliu</td>
              </tr>
              <tr>
                <td>FedEx-美国件</td>
                <td>fedexus</td>
              </tr>
              <tr>
                <td>OCS</td>
                <td>ocs</td>
              </tr>
              <tr>
                <td>巴西(Brazil Post/Correios)</td>
                <td>brazilposten</td>
              </tr>
              <tr>
                <td>孔夫子</td>
                <td>kongfzorder</td>
              </tr>
              <tr>
                <td>一号店</td>
                <td>yhdshoporder</td>
              </tr>
              <tr>
                <td>卷皮</td>
                <td>juanpiorder</td>
              </tr>
              <tr>
                <td>淘宝订单</td>
                <td>taobaoorder</td>
              </tr>
              <tr>
                <td>盛丰物流</td>
                <td>shengfengwuliu</td>
              </tr>
              <tr>
                <td>瑞典（Sweden Post）</td>
                <td>ruidianyouzheng</td>
              </tr>
              <tr>
                <td>圆通速递</td>
                <td>yuantong</td>
              </tr>
              <tr>
                <td>宅急送</td>
                <td>zhaijisong</td>
              </tr>
              <tr>
                <td>新邦物流</td>
                <td>xinbangwuliu</td>
              </tr>
              <tr>
                <td>恒路物流</td>
                <td>hengluwuliu</td>
              </tr>
              <tr>
                <td>华夏龙</td>
                <td>huaxialongwuliu</td>
              </tr>
              <tr>
                <td>龙飞祥快递</td>
                <td>longfx</td>
              </tr>
              <tr>
                <td>城市映急</td>
                <td>city56</td>
              </tr>
              <tr>
                <td>五六快运</td>
                <td>56kuaiyun</td>
              </tr>
              <tr>
                <td>速通物流</td>
                <td>sut56</td>
              </tr>
              <tr>
                <td>迅达速递</td>
                <td>xdexpress</td>
              </tr>
              <tr>
                <td>JDIEX</td>
                <td>jdiex</td>
              </tr>
              <tr>
                <td>泰捷达国际物流</td>
                <td>ztjieda</td>
              </tr>
              <tr>
                <td>捎客物流</td>
                <td>shaoke</td>
              </tr>
              <tr>
                <td>全球速递</td>
                <td>pdstow</td>
              </tr>
              <tr>
                <td>安达易国际速递</td>
                <td>adiexpress</td>
              </tr>
              <tr>
                <td>番薯国际货运</td>
                <td>koali</td>
              </tr>
              <tr>
                <td>贝贝</td>
                <td>beibeiorder</td>
              </tr>
              <tr>
                <td>德邦快递</td>
                <td>debangkuaidi</td>
              </tr>
              <tr>
                <td>联合速运</td>
                <td>unitedex</td>
              </tr>
              <tr>
                <td>龙邦物流</td>
                <td>lbex</td>
              </tr>
              <tr>
                <td>GHT物流</td>
                <td>ghtexpress</td>
              </tr>
              <tr>
                <td>香港伟豪国际物流</td>
                <td>whgjkd</td>
              </tr>
              <tr>
                <td>澳洲迈速快递</td>
                <td>maxeedexpress</td>
              </tr>
              <tr>
                <td>TCXB国际物流</td>
                <td>tcxbthai</td>
              </tr>
              <tr>
                <td>波音速递</td>
                <td>overseaex</td>
              </tr>
              <tr>
                <td>鑫远东速运</td>
                <td>xyd666</td>
              </tr>
              <tr>
                <td>中环快递</td>
                <td>zhonghuan</td>
              </tr>
              <tr>
                <td>沃埃家</td>
                <td>wowvip</td>
              </tr>
              <tr>
                <td>OBOR Express</td>
                <td>oborexpress</td>
              </tr>
              <tr>
                <td>盛丰物流</td>
                <td>sfwl</td>
              </tr>
              <tr>
                <td>速达通</td>
                <td>sdto</td>
              </tr>
              <tr>
                <td>苏豪快递</td>
                <td>shipsoho</td>
              </tr>
              <tr>
                <td>三盛快递</td>
                <td>sanshengco</td>
              </tr>
              <tr>
                <td>迅速快递</td>
                <td>xunsuexpress</td>
              </tr>
              <tr>
                <td>众川国际</td>
                <td>zhongchuan</td>
              </tr>
              <tr>
                <td>陆本速递 LUBEN EXPRESS</td>
                <td>luben</td>
              </tr>
              <tr>
                <td>西濃運輸</td>
                <td>seino</td>
              </tr>
              <tr>
                <td>加拿大联通快运</td>
                <td>fastontime</td>
              </tr>
              <tr>
                <td>花瓣转运</td>
                <td>flowerkd</td>
              </tr>
              <tr>
                <td>合心速递</td>
                <td>hexinexpress</td>
              </tr>
              <tr>
                <td>Highsince</td>
                <td>highsince</td>
              </tr>
              <tr>
                <td>蜜蜂速递</td>
                <td>bee001</td>
              </tr>
              <tr>
                <td>天使物流云</td>
                <td>tswlcloud</td>
              </tr>
              <tr>
                <td>王牌快递</td>
                <td>shipbyace</td>
              </tr>
              <tr>
                <td>华美快递</td>
                <td>hmus</td>
              </tr>
              <tr>
                <td>折800</td>
                <td>zhe800order</td>
              </tr>
              <tr>
                <td>小红书</td>
                <td>xiaohongshuorder</td>
              </tr>
              <tr>
                <td>铁中快运</td>
                <td>tzky</td>
              </tr>
              <tr>
                <td>景顺物流</td>
                <td>jingshun</td>
              </tr>
              <tr>
                <td>中环转运</td>
                <td>zhonghuanus</td>
              </tr>
              <tr>
                <td>YCG物流</td>
                <td>ycgglobal</td>
              </tr>
              <tr>
                <td>驿递汇速递</td>
                <td>yidihui</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="gotoBack">返回上一页</el-button>
    </div>
  </div>
</template>
<script>
import SettingApi from '@/api/setting.js';
export default {
  data() {
    return {
      tableData: [],
      loading: true
    };
  },
  created() {
    /*获取数据*/
    //this.getData();
  },
  methods: {

    /*获取数据*/
    getData() {
      let self = this;
      let Params = {};
      SettingApi.getCompany(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.data;
        })
        .catch(error => {});
    },

    /*返回上一页*/
    gotoBack(){
      this.$router.back(-1);
    }

  }
};
</script>
<style>
  .express-company{
    padding-bottom: 80px;
  }
.express-company table {
  width: 100%;
  border-collapse: collapse;
}
.express-company table th,
.express-company table td {
  padding: 12px;
  border: 1px solid #ebeef5;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/express/company.vue